{
	"language": {
		"select": "भाषा चुनें",
		"sectionTitle": "भाषा",
		"changeSuccess": "भाषा सफलतापूर्वक बदली गई।"
	},
	"assistant": {
		"composer": {
			"placeholder": "{{assistantName}} से पूछें",
			"disclaimer": "{{assistantName}} ग़लतियां कर सकता है। महत्वपूर्ण जानकारी की जांच करें।"
		},
		"greeting": {
			"initialMessage": "👋 नमस्ते, मैं **{{assistantName}}** लर्निंग असिस्टेंट हूं, और मैं आपको **{{context}}** के लिए बेहतर तैयारी में मदद करने के लिए यहां हूं! चलिए खास तौर पर उस आइटम पर गहराई से चर्चा करते हैं जिसका उत्तर आपने **{{topic}}** के बारे में दिया था।",
			"starter": "नमस्ते, मैं **{{assistantName}}** हूं। मैं आपकी कैसे मदद कर सकता हूं?"
		},
		"chips": {
			"askYourOwn": "अपना प्रश्न पूछें",
			"askFollowUp": "अनुवर्ती प्रश्न पूछें"
		},
		"emptyState": {
			"title": "{{assistantName}} आपका AI-संचालित लर्निंग असिस्टेंट है",
			"contextSubtitle": "{{context}} से संबंधित कुछ भी पूछें",
			"activateSubtitle": "{{assistantName}} प्रश्न का उत्तर देने के बाद सक्रिय होगा"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "क्विक स्टडी",
			"examInfo": {
				"subtitle": {
					"setExamDate": "परीक्षा की तारीख़ सेट करें",
					"examDateWithValue": "परीक्षा की तारीख़: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "बेहतर हो सकता है",
				"itsAwesome": "बहुत बढ़िया है"
			},
			"title": "आप कमाल कर रहे हैं!",
			"body": "आपके अध्ययन के प्रति समर्पण को देखकर हमें बहुत खुशी हो रही है! अब तक ऐप के साथ आपका अनुभव कैसा रहा है? क्या आप एक समीक्षा के ज़रिए अपने विचार साझा करना चाहेंगे?",
			"cta": "शायद बाद में"
		},
		"actions": {
			"studyWeak": "कमज़ोर क्षेत्रों पर ध्यान दें",
			"viewProgress": "अपनी प्रगति देखें",
			"seeRank": "अपनी रैंक देखें",
			"seeRankings": "लीडरबोर्ड देखें",
			"unlock": "प्रीमियम सामग्री अनलॉक करें",
			"unlockTooltip": "प्रीमियम सामग्री अनलॉक करके, खास सुविधाओं और उन्नत अध्ययन सामग्री तक पहुंच पाएं।",
			"startCustomSession": "कस्टम सत्र बनाएं",
			"startCustomSessionTooltip": "अपने अध्ययन के विशिष्ट क्षेत्रों पर ध्यान केंद्रित करने के लिए एक कस्टम अध्ययन सत्र शुरू करें।",
			"takeDiagnostic": "डायग्नोस्टिक लें",
			"takeDiagnosticTooltip": "अपने वर्तमान स्तर का आकलन करने और उसके अनुसार अपनी अध्ययन योजना बनाने के लिए डायग्नोस्टिक लें।",
			"viewDiagnostic": "डायग्नोस्टिक परिणाम देखें",
			"viewDiagnosticTooltip": "अपनी ताकत और सुधार के क्षेत्रों को देखने के लिए अपने डायग्नोस्टिक परिणाम देखें।",
			"viewPodcasts": "पॉडकास्ट सुनें",
			"viewPodcastsTooltip": "अपने सीखने के अनुभव को बेहतर बनाने के लिए शैक्षिक पॉडकास्ट तक पहुंच पाएं।",
			"upgradeToPremium": "प्रीमियम पाएं",
			"upgradeToPremiumTooltip": "सभी सामग्री और सुविधाओं तक पहुंच पाने के लिए प्रीमियम में अपग्रेड करें।",
			"extendAccess": "एक्सेस बढ़ाएं",
			"extendAccessTooltip": "प्रीमियम सामग्री और सुविधाओं तक अपना एक्सेस बढ़ाएं।",
			"setExamDate": "परीक्षा की तारीख़ सेट करें",
			"setExamDateTooltip": "अपनी प्रगति ट्रैक करने और परीक्षा की तैयारी करने के लिए अपनी परीक्षा की तारीख़ सेट करें।"
		},
		"exam": {
			"daysAgo_one": "{{count}} दिन पहले",
			"daysAgo_other": "{{count}} दिन पहले",
			"untilExam_one": "परीक्षा में {{count}} दिन बाकी",
			"untilExam_other": "परीक्षा में {{count}} दिन बाकी",
			"isToday": "आज परीक्षा है!"
		},
		"stats": {
			"mastery": "महारत",
			"completed_one": "उत्तर दिए गए आइटम",
			"completed_other": "उत्तर दिए गए आइटम",
			"completedValue": "{{count}}",
			"xpEarned": "अर्जित XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "सटीकता",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "आपकी अनुमानित {{skill, lowercase}} दक्षता {{level, lowercase}} है",
			"itemsAnsweredTooltip": "अब तक आपके द्वारा उत्तर दिए गए आइटम की कुल संख्या",
			"responsesAnsweredTooltip": "अब तक आपके द्वारा सबमिट किए गए उत्तरों की कुल संख्या",
			"examDateTooltip": "आपकी परीक्षा {{date}} को है",
			"skillCta": {
				"diagnostic": "डायग्नोस्टिक",
				"practice": "अभ्यास"
			}
		},
		"menu": {
			"settings": "सेटिंग",
			"profile": "प्रोफ़ाइल"
		},
		"diagnostics": {
			"title": "डायग्नोस्टिक",
			"free": "मुफ़्त",
			"duration": "{{count}} {{item}} • {{minutes}} मिनट",
			"completed": "{{count}} {{item}} पूर्ण",
			"start": "शुरू करें",
			"viewReport": "रिपोर्ट देखें",
			"resume": "फिर से शुरू करें"
		},
		"practiceTests": {
			"title": "प्रैक्टिस टेस्ट",
			"sectionalTestsTitle": "सेक्शनल टेस्ट",
			"diagnosticAssessmentsTitle": "डायग्नोस्टिक मूल्यांकन",
			"premiumChipTooltip": "{{examName}} परीक्षा के लिए पूर्ण-लंबाई वाले, प्रीमियम प्रैक्टिस टेस्ट",
			"freeChipTooltip": "{{examName}} परीक्षा के लिए {{label}}",
			"freeChipTooltipDefault": "{{examName}} परीक्षा के लिए मुफ़्त डायग्नोस्टिक मूल्यांकन",
			"completedDescription_one": "{{count}} आइटम • {{date}}",
			"completedDescription_other": "{{count}} आइटम • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} आइटम • {{timeRemaining}} शेष",
			"activeDescription_other": "{{attempted}}/{{count}} आइटम • {{timeRemaining}} शेष",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} आइटम • {{timeRemaining}} शेष • शुरू हुआ: {{startedOn}} • समाप्त होगा: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} आइटम • {{timeRemaining}} शेष • शुरू हुआ: {{startedOn}} • समाप्त होगा: {{endsOn}}",
			"notStartedDescription_one": "{{count}} आइटम • {{duration}}",
			"notStartedDescription_other": "{{count}} आइटम • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} आइटम • {{duration}} • समाप्त होगा: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} आइटम • {{duration}} • समाप्त होगा: {{endsOn}}",
			"viewResultsCta": "परिणाम देखें",
			"startCta": "शुरू करें",
			"chips": {
				"items_one": "{{count}} आइटम",
				"items_other": "{{count}} आइटम",
				"progress_one": "{{attempted}}/{{count}} आइटम",
				"progress_other": "{{attempted}}/{{count}} आइटम",
				"timeRemaining": "{{time}} शेष",
				"startedOn": "{{date}} को शुरू हुआ",
				"endsOn": "{{date}} को समाप्त होगा",
				"timeLeft": "{{time}} बचा"
			},
			"status": {
				"notStarted": {
					"label": "शुरू नहीं हुआ",
					"section": "पूर्ण-लंबाई वाले प्रैक्टिस टेस्ट"
				},
				"inProgress": {
					"label": "प्रगति पर",
					"section": "प्रगति पर"
				},
				"completed": {
					"label": "पूर्ण",
					"section": "पूर्ण"
				},
				"legacyReports": {
					"label": "पुरानी रिपोर्ट",
					"section": "पुरानी रिपोर्ट"
				},
				"migratedReports": {
					"label": "माइग्रेट की गई रिपोर्ट",
					"section": "माइग्रेट की गई रिपोर्ट"
				}
			}
		},
		"skills": {
			"title": "कौशल",
			"unlockSubtitle": "अभ्यास करने के लिए प्रीमियम अनलॉक करें",
			"startCta": "अभ्यास करें",
			"freeItemsIncludedChip": "मुफ़्त आइटम शामिल",
			"freeItemsAnsweredSubtitle_one": "{{count, number}} मुफ़्त आइटम में से {{answered, number}} का उत्तर दिया गया",
			"freeItemsAnsweredSubtitle_other": "{{count, number}} मुफ़्त आइटम में से {{answered, number}} के उत्तर दिए गए",
			"progressCards": {
				"questionTypesTitle": "प्रश्न प्रकार के अनुसार प्रदर्शन",
				"questionTypesSubtitle": "{{skill}} प्रश्न प्रकारों में आपके अंक",
				"proficiencyTitle": "दक्षता के अनुसार प्रदर्शन",
				"proficiencySubtitle": "{{skill}} स्तरों में आपकी प्रगति",
				"questionTypeCardSubtitle": "दक्षता स्तर के अनुसार प्रगति",
				"bySkillTitle": "कौशल के अनुसार प्रदर्शन",
				"bySkillSubtitle": "सभी कौशलों में समग्र प्रगति",
				"needsImprovementTitle": "सुधार आवश्यक",
				"needsImprovementSubtitle": "आगे ध्यान देने वाले विषय",
				"skillPerformanceTitle": "{{skill}} प्रदर्शन",
				"skillPerformanceSubtitle": "प्रश्न प्रकार और दक्षता के अनुसार प्रगति",
				"skillLevelSubtitle": "इस कौशल स्तर में आपकी प्रगति",
				"skillsPerformanceTitle": "कौशल प्रदर्शन",
				"performanceByItemDifficulty": "आइटम दक्षता के अनुसार प्रदर्शन",
				"performanceByItemDifficultyCaption_one": "दक्षता स्तर के अनुसार आपकी सटीकता दिखाता है, जो {{count}} उत्तर दिया गया आइटम पर आधारित है।",
				"performanceByItemDifficultyCaption_other": "दक्षता स्तर के अनुसार आपकी सटीकता दिखाता है, जो {{count}} उत्तर दिए गए आइटम पर आधारित है।",
				"questionTypePartSubtitle": "{{skill}} · भाग {{part}}",
				"activityGoalTitle": "गतिविधि और लक्ष्य प्रगति",
				"recentActivityTitle": "हाल की गतिविधि",
				"goalProgressTitle": "लक्ष्य प्रगति",
				"goalProgressSubtitle": "समग्र स्कोर · पिछले 7 सप्ताह",
				"goalProgressInsight": "आप लगातार सुधार कर रहे हैं। आप अपने लक्ष्य से 14 अंक पीछे हैं और लगभग 3 सप्ताह में अपना लक्ष्य प्राप्त कर सकते हैं।",
				"goalProgressActualLabel": "आपका स्कोर",
				"goalProgressTargetLabel": "लक्ष्य",
				"goalProgressTimeAxisLabel": "समय",
				"goalProgressScoreAxisLabel": "समग्र प्रगति",
				"statusTitle": "आपकी स्थिति",
				"diagnosticsTitle": "डायग्नोस्टिक",
				"diagnosticsReviewCta": "समीक्षा करें",
				"strengthsFocusTitle": "मजबूत और सुधार वाले क्षेत्र",
				"strengthsFocusSubtitle": "आपके सबसे मजबूत क्षेत्र और वे प्रश्न प्रकार जिन्हें अधिक अभ्यास की आवश्यकता है",
				"strengthsLabel": "मजबूत क्षेत्र",
				"focusAreasLabel": "सुधार क्षेत्र",
				"recommendedNextStepLabel": "अनुशंसित अगला कदम",
				"recommendedNextStepCta": "शुरू करें",
				"practiceTestsViewMore": "सभी {{count}} टेस्ट देखें"
			},
			"proficiencySection": "दक्षता स्तर के अनुसार अभ्यास"
		},
		"recommendedTasks": {
			"sectionTitle": "आपके लिए अनुशंसित",
			"startSessionAction": "अभ्यास करें",
			"resumeAction": "जारी रखें",
			"reviewResultsAction": "परिणाम की समीक्षा करें",
			"startTestAction": "शुरू करें",
			"activeTestBody": "अपना चल रहा मूल्यांकन पूरा करें।",
			"completedTestBody": "अपने परिणाम और व्यक्तिगत इनसाइट की समीक्षा करें।",
			"diagnosticBody": "आधाररेखा प्राप्त करने और परीक्षा प्रारूप से परिचित होने के लिए {{label}} लें।",
			"diagnosticDefaultLabel": "मुफ़्त डायग्नोस्टिक",
			"practiceTestBody": "समयबद्ध मॉक टेस्ट के साथ अपनी तैयारी का आकलन करें।",
			"sectionalTestBody": "अपने {{skills}} कौशल का अभ्यास करने के लिए एक केंद्रित टेस्ट लें।",
			"weakSkillTitle": "अपने {{skill}} कौशल विकसित करें",
			"weakSkillBody": "{{questionType}} अभ्यास, उन क्षेत्रों पर केंद्रित जहां आपको सुधार की आवश्यकता है।",
			"strongSkillTitle": "अपने {{skill}} कौशल को तेज़ रखें",
			"strongSkillBody": "अतिरिक्त अभ्यास के साथ {{questionType}} में अपनी मजबूती बनाए रखें।",
			"mixedSkillTitle": "अपने {{skill}} कौशल में सुधार करें",
			"mixedSkillBody": "{{questionTypes}} जैसे प्रश्न प्रकारों का अभ्यास करें, उन क्षेत्रों पर ध्यान केंद्रित करते हुए जहां आपको सुधार की आवश्यकता है।",
			"higherDifficultySkillTitle": "{{proficiency}} तक स्तर बढ़ाएं",
			"higherDifficultySkillBody": "चूंकि अब आप {{questionType}} में अच्छा प्रदर्शन कर रहे हैं, अब कठिनाई बढ़ाने का समय है।",
			"itemsChip_one": "{{count}} आइटम",
			"itemsChip_other": "{{count}} आइटम",
			"timeRemainingChip": "{{minutes}} मिनट शेष",
			"timeRemainingChipCompact": "{{minutes}} मिनट"
		},
		"itemTypes": {
			"answeredLabel_one": "उत्तर दिया गया आइटम",
			"answeredLabel_other": "उत्तर दिए गए आइटम",
			"answeredAll": "सभी",
			"answeredPartial": "{{total}} में से {{answered}}",
			"cardSubtitleComplete": "सभी आइटम के उत्तर दिए गए",
			"cardSubtitlePartial": "{{total}} आइटम में से {{attempted}} के उत्तर दिए गए",
			"cardSubtitleResponses_one": "{{count}} प्रतिक्रिया",
			"cardSubtitleResponses_other": "{{count}} प्रतिक्रियाएं",
			"responsesLabel_one": "प्रतिक्रिया",
			"responsesLabel_other": "प्रतिक्रियाएं",
			"detail": {
				"skillLabel": "कौशल",
				"estimatedLevelLabel": "अनुमानित स्तर"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} प्रतिक्रिया",
			"responseCount_other": "{{count, number}} प्रतिक्रियाएं"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "मुफ़्त में {{count, number}} अभ्यास आइटम शामिल",
			"freeContentBannerTitle_other": "मुफ़्त में {{count, number}} अभ्यास आइटम शामिल",
			"freeContentBannerBody": "चुने गए {{skills}} आइटम कभी भी अभ्यास करें। पूर्ण स्टडी पैक अनलॉक करने के लिए अपग्रेड करें।",
			"freeContentBannerCta": "मुफ़्त अभ्यास शुरू करें",
			"freeSampleBanner": {
				"body_one": "{{categories}} के चुने गए आइटम कभी भी अभ्यास करें। {{count, number}} और आइटम अनलॉक करने के लिए अपग्रेड करें।",
				"body_other": "{{categories}} के चुने गए आइटम कभी भी अभ्यास करें। {{count, number}} और आइटम अनलॉक करने के लिए अपग्रेड करें।",
				"moreTags": "{{count, number}} और {{label}}",
				"cta": "अपग्रेड करें"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "देखें कि आप दूसरों की तुलना में कहां खड़े हैं।"
		},
		"home": {
			"title": "होम"
		},
		"podcasts": {
			"description": "विशेषज्ञों द्वारा प्रस्तुत ऑर्थोपेडिक पॉडकास्ट सुनें।"
		},
		"more": {
			"title": "अधिक सेटिंग"
		}
	},
	"emptyState": {
		"progress": {
			"title": "कोई अध्ययन प्रगति नहीं",
			"subtitle": "जैसे-जैसे आप अध्ययन करेंगे, आपकी प्रगति यहां दिखेगी।",
			"cta": "अभी अध्ययन करें"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "त्रुटि",
			"body": "सत्र बनाने में विफल रहा, कृपया फिर से प्रयास करें।"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "उन्नत",
			"highIntermediate": "मध्यवर्ती",
			"intermediate": "मध्यवर्ती",
			"basic": "प्रारंभिक",
			"none": "अनुत्तरित",
			"high": "महारत हासिल",
			"medium": "लगभग तैयार",
			"low": "अभ्यास ज़रूरी"
		}
	},
	"leaderboard": {
		"you": "यह आप हैं",
		"periods": {
			"all_time": "सर्वकालिक",
			"month": "इस महीने",
			"week": "इस सप्ताह"
		},
		"scope": {
			"global": "वैश्विक",
			"friends": "मित्र"
		},
		"friends": {
			"soon": "जल्द",
			"comingSoonTitle": "मित्र लीडरबोर्ड",
			"comingSoonBadge": "जल्द आ रहा है",
			"comingSoonDescription": "मित्रों के मुकाबले अपनी प्रगति ट्रैक करें और देखें कि कक्षा में सबसे आगे कौन है।"
		},
		"error": {
			"title": "कनेक्शन त्रुटि",
			"description": "लीडरबोर्ड लोड करने में असमर्थ। अपना कनेक्शन जांचें और फिर से प्रयास करें।",
			"tryAgain": "फिर से प्रयास करें"
		},
		"empty": {
			"title": "अभी तक कोई लीडर नहीं",
			"description": "जैसे-जैसे अधिक लोग अध्ययन करेंगे, रैंकिंग अपडेट होगी। सबसे पहले XP अर्जित करें और शीर्ष स्थान हासिल करें!",
			"startLearning": "अभी अध्ययन करें"
		},
		"topPerformers": "शीर्ष प्रदर्शनकर्ता",
		"yourPosition": "आपकी स्थिति",
		"rankings": "रैंकिंग",
		"rankingsRange": "रैंकिंग • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "रैंकिंग में शामिल होने के लिए XP अर्जित करें!",
			"description": "अपने पहले अंक अर्जित करने और लीडरबोर्ड में शामिल होने के लिए एक अध्ययन सत्र शुरू करें।",
			"cta": "अपना पहला सत्र शुरू करें"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "आप",
		"podium": {
			"first": "पहला",
			"second": "दूसरा",
			"third": "तीसरा"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>#{{rank}} से आगे निकलने के लिए</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>पोडियम से दूर</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "पाठ",
			"statusFilter": {
				"all": "सभी",
				"inProgress": "प्रगति में",
				"notStarted": "शुरू नहीं हुए",
				"completed": "पूर्ण"
			},
			"card": {
				"openCta": "खोलें",
				"resumeCta": "जारी रखें",
				"viewResultsCta": "परिणाम देखें",
				"duration_one": "{{count}} मिनट",
				"duration_other": "{{count}} मिनट"
			},
			"viewToggle": {
				"list": "सूची दृश्य",
				"grid": "ग्रिड दृश्य"
			},
			"empty": {
				"filteredTitle": "इस फ़िल्टर से मेल खाने वाला कोई पाठ नहीं",
				"filteredSubtitle": "कोई दूसरा स्थिति फ़िल्टर आज़माएँ",
				"filteredCta": "सभी दिखाएँ",
				"noneTitle": "कोई पाठ नहीं मिला",
				"noneSubtitle": "फ़िल्टर हटाकर देखें या नई खोज शुरू करें।",
				"noneCta": "सभी रीसेट करें"
			}
		},
		"home": {
			"hero": {
				"greeting": "स्वागत है, {{name}}!",
				"greetingNoName": "स्वागत है!"
			},
			"stats": {
				"modulesDone": "पूर्ण मॉड्यूल",
				"dayStreak": "दिनों की स्ट्रीक",
				"minutesToday": "आज के मिनट"
			},
			"suggested": {
				"title": "आपके लिए सुझाया गया",
				"openModuleCta": "मॉड्यूल खोलें",
				"status": {
					"ready": "तैयार",
					"next": "अगला"
				}
			},
			"all": {
				"title": "सभी पाठ"
			},
			"emptyState": {
				"title": "अभी तक कोई पाठ नहीं",
				"subtitle": "नए पाठों के लिए जल्द ही वापस देखें।"
			},
			"card": {
				"duration_one": "{{count}} मिनट",
				"duration_other": "{{count}} मिनट"
			}
		},
		"overview": {
			"header": {
				"title": "अवलोकन"
			},
			"startCta": "सीखना शुरू करें",
			"objectives": {
				"title": "सीखने के उद्देश्य"
			}
		},
		"detail": {
			"takeQuizCta": "क्विज़ लें",
			"progress": {
				"label": "मॉड्यूल प्रगति"
			},
			"activities": {
				"title": "गतिविधियां",
				"completedCount": "{{total}} में से {{completed}} पूर्ण"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "प्रगति इनसाइट"
			},
			"milestones": {
				"title": "मॉड्यूल के मील के पत्थर",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "पढ़ा गया"
			},
			"readTime": "{{count}} मिनट में पढ़ें",
			"sectionBadge": {
				"label": "{{total}} में से सेक्शन {{number}}"
			},
			"upNext": {
				"title": "अगला"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "कस्टम अध्ययन सत्र",
		"diagnostic": "डायग्नोस्टिक",
		"skill": "कौशल",
		"Proficiency": "दक्षता",
		"Question Type": "प्रश्न प्रकार",
		"mastery": "महारत",
		"sessionLength": "सत्र की अवधि",
		"itemsChip_one": "{{count}} आइटम",
		"itemsChip_other": "{{count}} आइटम",
		"durationEstimate": "{{minutes}} मिनट",
		"durationRange": "{{min}}–{{max}} मिनट",
		"noItemsTooltip": "मौजूदा फ़िल्टर से कोई आइटम मेल नहीं खाता।",
		"setCount": "{{count}} {{type}}",
		"dismiss": "ठीक है",
		"status": {
			"notAnswered": "अनुत्तरित",
			"needsWork": "अभ्यास ज़रूरी"
		},
		"itemCount": "आप {{topics}} में {{count}} आइटम पूरे करेंगे।",
		"start": "सत्र शुरू करें",
		"configuringSession": "सत्र कॉन्फ़िगर किया जा रहा है",
		"fetchingContent": "सामग्री लाई जा रही है",
		"preparingMaterials": "सामग्री तैयार की जा रही है",
		"almostThere": "लगभग तैयार",
		"startingSession": "सत्र शुरू हो रहा है",
		"playIcon": "play-outline",
		"infoText": "आप **{{numItems}}** {{itemCount}} पूरे करेंगे। इसमें लगभग **{{timeString}}** समय लगेगा।",
		"customSummary": {
			"message": "{{topics}} से $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) का अध्ययन करें।",
			"messageWithMastery": "{{topics}} से $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) का अध्ययन करें, {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) पर ध्यान केंद्रित करते हुए।",
			"messageAllMasteryLevels": "{{topics}} से सभी महारत स्तरों में $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) का अध्ययन करें।",
			"itemCount_one": "{{count}} आइटम",
			"itemCount_other": "{{count}} आइटम",
			"masteryLevelCount_one": "महारत स्तर",
			"masteryLevelCount_other": "महारत स्तर",
			"allTopics": "सभी {{count}} विषय",
			"more": "{{count}} और",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "क्विक स्टडी",
			"recommended": "अनुशंसित",
			"custom": "कस्टम",
			"selectHelper": "सत्र चुनने के लिए उस पर टैप करें, फिर तैयार होने पर शुरू करें।",
			"emptyRecommended": "अभी कोई अनुशंसित सत्र उपलब्ध नहीं है।",
			"summary": "{{skill}} से {{count}} आइटम का अध्ययन करें। अनुमानित {{minutes}} मिनट।",
			"summary_questionType": "{{skill}}, {{questionType}} से {{count}} आइटम का अध्ययन करें। अनुमानित {{minutes}} मिनट।",
			"duration": "{{minutes}} मिनट",
			"durationSelector": {
				"title": "अवधि"
			},
			"levelSessions": {
				"rapidRecall": "त्वरित स्मरण",
				"purposefulPractice": "उद्देश्यपूर्ण अभ्यास",
				"focusFlow": "फोकस प्रवाह",
				"itemsLabel": "{{level}} आइटम",
				"itemsLabelGeneric": "आइटम",
				"summaries": {
					"rapidRecall": "अपनी कवरेज को लगातार बढ़ाने के लिए, उन {{count}} {{level}} आइटम पर एक त्वरित नज़र डालें जिनका आपने अभी तक उत्तर नहीं दिया है। अनुमानित {{minutes}} मिनट।",
					"purposefulPractice": "उस सामग्री से शुरू करते हुए जिसे सबसे ज़्यादा अभ्यास की ज़रूरत है, {{count}} {{level}} आइटम के संतुलित सेट पर काम करें। अनुमानित {{minutes}} मिनट।",
					"focusFlow": "निम्न या मध्यम महारत के साथ उत्तर दिए गए {{count}} {{level}} आइटम से अपनी कमज़ोरियों को मज़बूत करें। अनुमानित {{minutes}} मिनट।"
				},
				"summariesGeneric": {
					"rapidRecall": "अपनी कवरेज को लगातार बढ़ाने के लिए, उन {{count}} आइटम पर एक त्वरित नज़र डालें जिनका आपने अभी तक उत्तर नहीं दिया है। अनुमानित {{minutes}} मिनट।",
					"purposefulPractice": "उस सामग्री से शुरू करते हुए जिसे सबसे ज़्यादा अभ्यास की ज़रूरत है, {{count}} आइटम के संतुलित सेट पर काम करें। अनुमानित {{minutes}} मिनट।",
					"focusFlow": "निम्न या मध्यम महारत के साथ उत्तर दिए गए {{count}} आइटम से अपनी कमज़ोरियों को मज़बूत करें। अनुमानित {{minutes}} मिनट।"
				}
			},
			"lockedOptionsBanner": "प्रीमियम के साथ {{names}} अनलॉक करें",
			"lockedOptionsBannerOverflow": "प्रीमियम के साथ {{names}} और {{count}} अन्य अनलॉक करें"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "अपने अनुभव को व्यक्तिगत बनाने के लिए, डायग्नोस्टिक क्विज़ से शुरुआत करें। आपके डायग्नोस्टिक के परिणामों का उपयोग आपकी अध्ययन योजना बनाने के लिए किया जाएगा।"
	},
	"premium": {
		"chip": "प्रीमियम",
		"upgrade": "प्रीमियम में अपग्रेड करें",
		"unlockTitle": "अपना पूर्ण {{productName}} अनुभव अनलॉक करें",
		"unlockDescription": "अपने बचे हुए अध्ययन समय के अनुसार तैयार किया गया व्यक्तिगत अभ्यास अनलॉक करें।",
		"readyTitle": "अपनी {{date}} की परीक्षा के लिए तैयार रहें",
		"tip": "आपका व्यक्तिगत फ़ोकस, प्रीमियम यह पहचानता है कि आगे क्या अभ्यास करना है और जैसे-जैसे आप सुधरते हैं, आपका अध्ययन प्लान समायोजित करता है।"
	},
	"purchase": {
		"success": {
			"headerTitle": "आपकी खरीद के लिए धन्यवाद!",
			"accessGranted": "आपके {{name}} तक पहुंच सफलतापूर्वक प्रदान की गई है",
			"studyPack": "स्टडी-पैक",
			"practiceTest": "प्रैक्टिस टेस्ट",
			"combo": "कॉम्बो",
			"documentTitle": "खरीद",
			"summary_one": "बधाई हो! नीचे दिया गया **उत्पाद** आपके खाते में अनलॉक कर दिया गया है। {{action}} बटन दबाने के बाद, आपके ऐप का संदर्भ बदलकर इस परीक्षा को दर्शाएगा: **{{examName}}**। यदि आप किसी अन्य परीक्षा के लिए अध्ययन करना या कोई अन्य उत्पाद खरीदना चाहते हैं, तो आप इसे कभी भी अपनी खाता सेटिंग से बदल सकते हैं।",
			"summary_other": "बधाई हो! नीचे दिए गए **{{count}} उत्पाद** आपके खाते में अनलॉक कर दिए गए हैं। {{action}} बटन दबाने के बाद, आपके ऐप का संदर्भ बदलकर इस परीक्षा को दर्शाएगा: **{{examName}}**। यदि आप किसी अन्य परीक्षा के लिए अध्ययन करना या कोई अन्य उत्पाद खरीदना चाहते हैं, तो आप इसे कभी भी अपनी खाता सेटिंग से बदल सकते हैं।",
			"unlockedDuration": "बधाई हो! आपने **{{name}}** के लिए **{{duration}}** की पहुंच अनलॉक कर ली है। यह **{{expiry}}** को समाप्त होगी।",
			"storeNote": "ध्यान दें: स्टडी-पैक केवल हमारे मोबाइल ऐप से ही एक्सेस किए जा सकते हैं। कृपया अपने डिवाइस के लिए उपयुक्त ऐप डाउनलोड करें।",
			"actions": {
				"goToHome": "होम पर जाएं",
				"startDiagnostic": "{{label}} शुरू करें",
				"takeDiagnostic": "{{label}} लें",
				"takeFreeDiagnostic": "मुफ़्त डायग्नोस्टिक लें",
				"diagnosticLabel": "डायग्नोस्टिक"
			}
		},
		"checkout": {
			"headerTitle": "अपनी खरीद पूरी करें"
		},
		"paywall": {
			"studyPackDialogTitle": "अपना अध्ययन प्लान अपग्रेड करें",
			"defaultDialogTitle": "अपना अध्ययन प्लान अपग्रेड करें",
			"practiceTestDialogTitle": "प्रैक्टिस टेस्ट अनलॉक करें",
			"restorePurchaseDialogTitle": "पहले ही खरीद चुके हैं?",
			"restorePurchaseDialogSubheadingWeb": "यदि नहीं, तो यह आज़माएं:",
			"restorePurchaseDialogBody": "यदि आपने पहले ही यह उत्पाद खरीद लिया है और यह अभी भी लॉक है, तो कृपया निम्नलिखित आज़माएं:\n\n1. सुनिश्चित करें कि आप सही खाते में लॉग इन हैं\n2. सुनिश्चित करें कि आपने सही उत्पाद चुना है\n3. सुनिश्चित करें कि आपका सब्सक्रिप्शन समाप्त नहीं हुआ है\n4. सुनिश्चित करें कि आपने अपना सब्सक्रिप्शन सक्रिय कर लिया है (अपना जंक मेल जांचें)\n5. यदि आपके पास एक्सेस कोड है, तो [एक्सेस कोड]({{baseUrl}}/redeem)\n\nयदि इनमें से कोई भी लागू नहीं होता, तो कृपया **यहां क्लिक करें**",
			"restorePurchaseDialogBodyWeb": "1. सुनिश्चित करें कि आप सही ईमेल में लॉग इन हैं\n2. सुनिश्चित करें कि आपने सही **[परीक्षा चुनी है](/account/settings)**\n3. सुनिश्चित करें कि आपका सब्सक्रिप्शन समाप्त नहीं हुआ है\n\nयदि इनमें से कोई भी लागू नहीं होता, तो कृपया **सहायता से संपर्क करें**",
			"accesDuration": {
				"yearPlan": "**{{duration}}** प्लान विस्तारित पहुंच प्रदान करता है, जिससे आपको अपनी गति से अध्ययन करने और अपनी परीक्षा की पूरी तैयारी करने की अधिकतम सुविधा मिलती है।",
				"moreTime": "यदि आपको लगता है कि आपको अध्ययन के लिए अधिक समय चाहिए, तो आप **{{duration}}** प्लान चुन सकते हैं।",
				"otherPlan": "**{{duration}}** प्लान आपको **{{expiryText}}** तक पहुंच प्रदान करेगा, जिससे आपको अध्ययन के लिए पर्याप्त समय मिलेगा। {{moreTime}}"
			},
			"actions": {
				"upgrade": "अपग्रेड करें",
				"unlock": "{{price}} में अनलॉक करें",
				"subscribe": "{{price}} में सब्सक्राइब करें",
				"extendAccess": "पहुंच बढ़ाएं",
				"accessHere": "यहां एक्सेस करें",
				"redeemAccessCode": "आपके पास एक्सेस कोड है?",
				"restorePurchase": "पहले ही खरीद चुके हैं?",
				"restorePurchaseWeb": "पहले ही खरीद चुके हैं या आपके पास एक्सेस कोड है?"
			},
			"subscriptionSummary": {
				"yearly": "वार्षिक सब्सक्रिप्शन • ऑटो-नवीनीकरण • कभी भी रद्द करें",
				"monthly": "मासिक सब्सक्रिप्शन • ऑटो-नवीनीकरण • कभी भी रद्द करें",
				"weekly": "साप्ताहिक सब्सक्रिप्शन • ऑटो-नवीनीकरण • कभी भी रद्द करें",
				"generic": "ऑटो-नवीनीकरण सब्सक्रिप्शन • कभी भी रद्द करें"
			},
			"planDuration": {
				"day_one": "{{count}} दिन",
				"day_other": "{{count}} दिन",
				"week_one": "{{count}} सप्ताह",
				"week_other": "{{count}} सप्ताह",
				"month_one": "{{count}} महीना",
				"month_other": "{{count}} महीने",
				"year_one": "{{count}} वर्ष",
				"year_other": "{{count}} वर्ष"
			},
			"recommendedPlan": {
				"plan": "हम आपकी **{{date}}** की परीक्षा की सर्वोत्तम तैयारी के लिए \"**{{duration}}**\" प्लान की सलाह देते हैं",
				"subscription": {
					"yearly": "हम आपकी **{{date}}** की परीक्षा के लिए निरंतर पहुंच और तैयारी हेतु **वार्षिक सब्सक्रिप्शन** की सलाह देते हैं",
					"monthly": "हम आपकी **{{date}}** की परीक्षा के लिए निरंतर पहुंच और तैयारी हेतु **मासिक सब्सक्रिप्शन** की सलाह देते हैं",
					"weekly": "हम आपकी **{{date}}** की परीक्षा के लिए निरंतर पहुंच और तैयारी हेतु **साप्ताहिक सब्सक्रिप्शन** की सलाह देते हैं",
					"generic": "हम आपकी **{{date}}** की परीक्षा के लिए निरंतर पहुंच और तैयारी हेतु **सब्सक्रिप्शन** की सलाह देते हैं"
				}
			},
			"disclaimer": "खरीद की पुष्टि पर आपको चुनी गई अवधि के लिए इस उत्पाद की सामग्री तक पूर्ण पहुंच प्रदान की जाएगी। इस अवधि की समाप्ति पर, आप प्रतिबंधित सामग्री तक पहुंच खो देंगे। यदि आप किसी भी कारण से अपनी पहुंच बढ़ाना चाहते हैं (उदा. आपने अपनी परीक्षा की तारीख़ बदली है), तो आप अतिरिक्त इन-ऐप खरीद के माध्यम से समय जोड़ सकते हैं। अधिक जानकारी के लिए, हमारी [सेवा की शर्तें और गोपनीयता नीति](https://memorang.com/legal) देखें।"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}} {{type}} में {{numItems}} {{item}} के उत्तर के आधार पर",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "यह {{count}} {{type}} में आपकी प्रगति दिखाता है। यह अब तक आपके द्वारा उत्तर दिए गए {{itemCount}} {{item}} पर आधारित है।"
		},
		"needsImprovement": {
			"title": "सुधार की ज़रूरत",
			"subtitle": "आपके सुधार के लिए अनुशंसित {{type}}",
			"cta": "अभी अध्ययन करें"
		},
		"mastery": {
			"high": "महारत हासिल",
			"medium": "लगभग तैयार",
			"low": "अभ्यास ज़रूरी",
			"count": "{{count}} {{item}} का उत्तर दिया गया",
			"zeroTooltip": "उत्तर दिए गए {{total}} आइटम में से अभी तक कोई {{label}} आइटम नहीं",
			"highTooltip": "आपने उत्तर दिए गए {{total}} {{item}} में से {{count}} में महारत हासिल की है",
			"mediumTooltip": "आप उत्तर दिए गए {{total}} {{item}} में से {{count}} पर प्रगति कर रहे हैं",
			"lowTooltip": "आपको उत्तर दिए गए {{total}} {{item}} में से {{count}} के साथ अधिक अभ्यास की ज़रूरत है"
		},
		"stats": {
			"completion": "पूर्णता",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "आपने {{total}} {{item}} में से {{completed}} पूरे कर लिए हैं"
		},
		"exams": {
			"title": "प्रैक्टिस टेस्ट",
			"subtitle_one": "{{count}} पूर्ण मूल्यांकन के आधार पर",
			"subtitle_other": "{{count}} पूर्ण मूल्यांकन के आधार पर"
		},
		"summary": {
			"title": "अध्ययन सारांश",
			"subtitle": "{{count}} {{item}} के उत्तर के आधार पर",
			"tooltip": "यह सारांश कुल {{count}} {{item}} में आपके महारत स्तर और पूर्णता प्रगति को दिखाता है। आपके प्रदर्शन को अध्ययन सत्रों, मूल्यांकनों और अध्ययन गतिविधियों के माध्यम से मापा जाता है।",
			"mastery": "महारत",
			"quickStats": "त्वरित आंकड़े"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}} दक्षता",
			"proficiencyCardTooltip": "आप वर्तमान में {{level, lowercase}} {{skill, lowercase}} स्तर पर प्रदर्शन कर रहे हैं",
			"itemTypesCardSubtitle_one": "{{count}} आइटम प्रकार",
			"itemTypesCardSubtitle_other": "{{count}} आइटम प्रकार",
			"itemTypesCardTitle": "{{skill}} आइटम",
			"itemTypeLevelTooltip": "आप “{{itemType}}” प्रश्न प्रकार पर वर्तमान में {{level, lowercase}} {{skill, lowercase}} स्तर पर प्रदर्शन कर रहे हैं",
			"itemTypesFallbackTitle": "आइटम प्रकार",
			"itemTypesEmptyTitle": "आइटम प्रकार अनुपलब्ध",
			"itemTypesEmptySubtitle": "हमें इस कौशल के लिए आइटम प्रकार नहीं मिले। प्रगति पर वापस जाएं और फिर से प्रयास करें।",
			"itemTypesEmptyCta": "प्रगति पर वापस जाएं",
			"notAnswered": "अनुत्तरित",
			"answeredSubtitle_one": "{{count}} आइटम के उत्तर के आधार पर",
			"answeredSubtitle_other": "{{count}} आइटम के उत्तर के आधार पर",
			"responsesSubtitle_one": "{{count}} प्रतिक्रिया के आधार पर",
			"responsesSubtitle_other": "{{count}} प्रतिक्रियाओं के आधार पर",
			"testsTakenSubtitle_one": "{{count}} दिए गए टेस्ट के आधार पर",
			"testsTakenSubtitle_other": "{{count}} दिए गए टेस्ट के आधार पर",
			"startFirstTest": {
				"title": "चलिए शुरू करते हैं",
				"itemsSubtitle_one": "{{count}} आइटम",
				"itemsSubtitle_other": "{{count}} आइटम",
				"guidance": {
					"diagnostic": "अपनी ताकत जानने और अपनी अध्ययन योजना तैयार करने के लिए डायग्नोस्टिक से शुरुआत करें।",
					"sectional": "सेक्शनल टेस्ट परीक्षा के एक भाग पर केंद्रित होता है, जिससे आपको कम समय में स्कोर मिल जाता है।",
					"fullMock": "पूर्ण मॉक टेस्ट वास्तविक परीक्षा को शुरू से अंत तक प्रतिबिंबित करता है और आपको सबसे संपूर्ण स्कोर देता है।"
				}
			},
			"noScoresTitle": "अभी तक कोई {{skill, lowercase}} स्कोर नहीं",
			"noScoresSubtitle": "अपना अनुमानित स्कोर और टास्क ब्रेकडाउन देखने के लिए अपना पहला टेस्ट लें।",
			"noScoresCta": "शुरू करें",
			"noScoresCardSubtitle": "आप जो टेस्ट देंगे उनके आधार पर",
			"personalBestLabel": "आपका व्यक्तिगत सर्वश्रेष्ठ",
			"latestLabel": "आपका नवीनतम",
			"examCountdown_one": "आपकी परीक्षा {{count}} दिन में है",
			"examCountdown_other": "आपकी परीक्षा {{count}} दिनों में है",
			"greeting": {
				"none": "चलिए शुरू करते हैं, {{firstName}}! 🚀",
				"low": "अच्छी शुरुआत, {{firstName}} — जारी रखें! 💪",
				"medium": "ऐसे ही जारी रखें, {{firstName}}! 💪",
				"high": "आप लगभग तैयार हैं, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "चलिए शुरू करते हैं! 🚀",
				"low": "अच्छी शुरुआत — जारी रखें! 💪",
				"medium": "ऐसे ही जारी रखें! 💪",
				"high": "आप लगभग तैयार हैं! 🎯"
			},
			"stats": {
				"untilExam": "परीक्षा की तारीख़",
				"itemsAnswered": "उत्तर दिए गए आइटम",
				"responsesAnswered": "प्रतिक्रियाएं"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "ग़लत पासकोड",
		"incorrectPassword": "ग़लत पासवर्ड। कृपया फिर से प्रयास करें।",
		"passwordPlaceholder": "पासवर्ड दर्ज करें",
		"emailPlaceholder": "उदा., dave@gmail.com",
		"verify": {
			"openEmail": "जारी रखने के लिए ईमेल खोलें",
			"signInCta": "आपका खाता सत्यापित किया जा रहा है...",
			"signUpCta": "आपका खाता बनाया जा रहा है...",
			"contactSupport": "ईमेल नहीं दिख रहा? अपना स्पैम फ़ोल्डर जांचें या",
			"contactSupportLink": "हमसे संपर्क करें",
			"resendMagicLink": "मैजिक लिंक फिर से भेजें",
			"resendMagicLinkIn": "{{time}} में मैजिक लिंक फिर से भेजें",
			"signInBody": "आप लगभग पहुंच गए हैं! {{appName}} ऐप में सुरक्षित रूप से साइन इन करने के लिए आपके विवरण सत्यापित किए जा रहे हैं।",
			"signUpBody": "लगभग हो गया! आपका नया {{appName}} ऐप खाता बनाने के लिए हम आपके विवरण सत्यापित कर रहे हैं।",
			"magicLinkEmail": "हमने **{{email}}** पर एक मैजिक लिंक भेजा है\nसुरक्षित रूप से साइन इन करने के लिए अपने ईमेल में दिए गए लिंक पर क्लिक करें।",
			"magicLinkEmailExpiry": "यह लिंक 10 मिनट में समाप्त हो जाएगा",
			"confirmEmail": "अपने ईमेल की पुष्टि करें",
			"redirectingToApp": "{{appName}} ऐप पर रीडायरेक्ट किया जा रहा है...",
			"appNotOpen": "ऐप नहीं खुला? संबंधित एप्लिकेशन खोलने के लिए नीचे दिए गए बटन पर क्लिक करें",
			"openApp": "{{appName}} ऐप खोलें",
			"installAppPrompt": "यदि कुछ नहीं होता है, तो सुनिश्चित करें कि आपके डिवाइस पर {{appName}} ऐप इंस्टॉल है",
			"verifyAccountTitle": "अपना खाता सत्यापित करें",
			"emailResent": "{{email}} पर मैजिक लिंक भेजा गया\nकृपया स्पैम सहित अपना इनबॉक्स जांचें।",
			"verificationLinkExpired": "सत्यापन लिंक समाप्त हो गया",
			"verificationLinkExpiredBody": "सत्यापन लिंक 10 मिनट बाद समाप्त हो जाते हैं और इन्हें केवल एक बार इस्तेमाल किया जा सकता है। \nआप दोबारा लॉग इन करके नया लिंक मांग सकते हैं",
			"accountSetupTimeoutTitle": "साइन इन पूरा करने में असमर्थ",
			"accountSetupTimeoutBody": "आपका खाता सेट अप होने में अपेक्षा से अधिक समय ले रहा है। कृपया फिर से लॉग इन करने का प्रयास करें या यदि यह जारी रहता है तो सहायता से संपर्क करें।",
			"loginAgain": "फिर से लॉग इन करें",
			"contactSupportExpiredLink": "यदि यह समस्या बनी रहती है, तो हमें बताएं",
			"successTitle": "अब आप दूसरे टैब में साइन इन हैं",
			"successBody": "इस टैब को बंद करें या यहां से जारी रखें",
			"successCtaLabel": "यहां से जारी रखें",
			"needHelpLabel": "मदद चाहिए?",
			"contactSupportButton": "सहायता से संपर्क करें"
		},
		"contactSupportDialog": {
			"title": "लॉग इन करने में समस्या?",
			"body": "यदि आपको लॉग इन करने में समस्या हो रही है, तो कृपया हमारी ग्राहक सहायता टीम से संपर्क करें या फिर से प्रयास करें",
			"cta": "हमें ईमेल करें"
		},
		"emailInstruction": {
			"default": "यदि आपको ईमेल नहीं मिलता है, तो अपने जंक, स्पैम और हाल ही में हटाए गए फ़ोल्डर जांचें",
			"edu": "यदि आपको ईमेल नहीं मिलता है, तो अपने जंक, स्पैम और हाल ही में हटाए गए फ़ोल्डर जांचें, या अपने IT प्रशासक से संपर्क करें"
		},
		"createSessionLoader": {
			"configuringSession": "सत्र कॉन्फ़िगर किया जा रहा है",
			"analyzingMastery": "महारत का विश्लेषण किया जा रहा है",
			"loadingContent": "सामग्री लोड की जा रही है"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "हम आपको क्या कहकर बुलाएं?",
				"description": "आपका उपयोगकर्ता नाम सार्वजनिक लीडरबोर्ड पर दिखता है, जबकि आपका नाम निजी रहता है।",
				"usernameLabel": "उपयोगकर्ता नाम",
				"firstNameLabel": "पहला नाम",
				"lastNameLabel": "अंतिम नाम",
				"avatarLabel": "अवतार",
				"avatarTooltip": "अवतार आपके उपयोगकर्ता नाम के आधार पर स्वचालित रूप से बनाए जाते हैं।",
				"profileSaveFailed": "हम आपकी प्रोफ़ाइल सेव नहीं कर सके। कृपया फिर से प्रयास करें।"
			},
			"testDate": {
				"cta": "जारी रखें"
			},
			"examDate": {
				"daysAway": "इससे हमें {{value}} दिन मिलते हैं। हम तुरंत आपके सबसे कमज़ोर क्षेत्रों को प्राथमिकता देंगे।"
			},
			"skills": {
				"chooseAll": "जो भी लागू हों, वे सभी चुनें"
			},
			"plan": {
				"recommended": "अनुशंसित"
			},
			"toeicLevelOverview": {
				"title": "हर कोई कहीं न कहीं से शुरुआत करता है।",
				"description": "अभ्यास आपको अगले स्तर पर स्वाभाविक रूप से बढ़ने से पहले एक स्तर पर महारत हासिल करने में मदद करता है।",
				"illustrationLabel": "प्रारंभिक (A1–A2) से मध्यवर्ती (B1–B2) होते हुए प्रवीण (C1) तक की प्रगति।",
				"levels": {
					"basic": {
						"name": "प्रारंभिक",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "मध्यवर्ती",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "प्रवीण",
						"band": "C1"
					}
				},
				"progression": {
					"title": "आप कैसे आगे बढ़ेंगे",
					"practiceSessions": "अनुशंसित सत्रों का अभ्यास करें",
					"buildMastery": "अपने वर्तमान स्तर पर महारत हासिल करें",
					"growToward": "प्रवीण की ओर बढ़ना जारी रखें"
				},
				"levelDetails": {
					"title": "प्रत्येक स्तर का क्या अर्थ है",
					"scoreRange": "{{band}} · स्कोर {{min}}–{{max}}",
					"basic": {
						"name": "प्रारंभिक उपयोगकर्ता",
						"summary": "सरल कार्यस्थल अंग्रेज़ी",
						"examples": {
							"forms": "फ़ॉर्म और सूचनाएं",
							"instructions": "निर्देश",
							"announcements": "छोटी घोषणाएं"
						}
					},
					"intermediate": {
						"name": "मध्यवर्ती उपयोगकर्ता",
						"summary": "रोज़मर्रा का कार्यस्थल संचार",
						"examples": {
							"emails": "ईमेल और बातचीत",
							"customers": "ग्राहकों से बातचीत",
							"followUps": "मीटिंग फ़ॉलो-अप"
						}
					},
					"proficient": {
						"name": "प्रवीण उपयोगकर्ता",
						"summary": "व्यावसायिक और उन्नत अंग्रेज़ी",
						"examples": {
							"reports": "जटिल रिपोर्ट और प्रस्तुतियां",
							"negotiations": "सूक्ष्म वार्ताएं",
							"highStakes": "उच्च जोखिम वाले व्यावसायिक संदर्भ"
						}
					}
				},
				"disclaimer": "TOEIC Link स्कोर CEFR-संरेखित दिशानिर्देश हैं, न कि पूर्ण कट स्कोर। रीडिंग और लिसनिंग स्वतंत्र रूप से आगे बढ़ते हैं — आप प्रत्येक कौशल में अलग-अलग स्तर तक पहुंच सकते हैं।"
			},
			"review": {
				"diagnosticChoice": {
					"title": "डायग्नोस्टिक: {{title}}",
					"body": "कहां ध्यान देना है यह जानने के लिए {{count}} आइटम",
					"duration": "{{minutes}} मिनट"
				},
				"homeChoice": {
					"title": "खुद से एक्सप्लोर करना",
					"body": "अभी शुरू करने के लिए तैयार नहीं, पहले ऐप एक्सप्लोर करना है"
				}
			}
		},
		"common": {
			"changeLater": "आप इसे बाद में बदल सकते हैं"
		},
		"actions": {
			"previous": "पिछला",
			"finish": "पूरा करें",
			"start": "शुरू करें",
			"continue": "जारी रखें",
			"stepIndicator": "{{total}} में से चरण {{step}}"
		}
	},
	"more": {
		"profile": {
			"title": "आपके बारे में"
		},
		"exam": {
			"title": "आपकी परीक्षा"
		},
		"subscriptions": {
			"title": "उत्पाद",
			"redeem": {
				"title": "खरीद रिडीम करें"
			},
			"extend": {
				"cta": "बढ़ाएं"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "अपनी लक्ष्य परीक्षा तारीख़ सेट करें",
			"description": "यह तारीख़ केवल ऐप के भीतर आपकी अध्ययन अनुसूची को निर्देशित करने के लिए है। यह आपके आधिकारिक परीक्षा पंजीकरण को प्रभावित नहीं करती।",
			"dismissCta": "अभी नहीं",
			"confirmCta": "परीक्षा तारीख़ सेट करें"
		}
	},
	"account": {
		"title": "खाता सेटिंग",
		"currentExam": "वर्तमान परीक्षा",
		"subscriptions": "उत्पाद",
		"examDate": "परीक्षा की तारीख़",
		"examDateUpdated": "परीक्षा की तारीख़ {{date}} पर सेट की गई",
		"selectDate": "तारीख़ चुनें",
		"appearance": "दिखावट",
		"features": "सुविधाएं",
		"audioPlaybackTest": "ऑडियो प्लेबैक टेस्ट डायलॉग दिखाएं",
		"theme": "थीम",
		"selectTheme": "थीम चुनें",
		"themeOptions": {
			"system": "सिस्टम",
			"light": "लाइट",
			"dark": "डार्क"
		},
		"accountInfo": "खाता",
		"username": "उपयोगकर्ता नाम",
		"name": "नाम",
		"nameNotSet": "सेट नहीं है",
		"save": "सेव करें",
		"editUsername": {
			"title": "उपयोगकर्ता नाम संपादित करें"
		},
		"editName": {
			"title": "नाम संपादित करें"
		},
		"email": "ईमेल",
		"dev": "डेवलपर",
		"sandbox": "सैंडबॉक्स",
		"redoOnboarding": "ऑनबोर्डिंग फिर से करें",
		"about": "जानकारी",
		"termsOfService": "सेवा की शर्तें",
		"privacyPolicy": "गोपनीयता नीति",
		"aiToolsTos": "AI टूल की उपयोग शर्तें",
		"support": "सहायता",
		"supportEmailBody": "यह संदेश आपको इसलिए भेजा जा रहा है क्योंकि मुझे [  ] में सहायता चाहिए\n\n\n\nचीज़ों को जल्दी सुलझाने में मदद के लिए यहां कुछ उपयोगी जानकारी दी गई है: \n\nखाते से जुड़ा उपयोगकर्ता नाम (ऐप में लॉग इन करने पर सेटिंग में मिलेगा):\n{{username}}\n\nमेरे ऑर्डर से जुड़ा ईमेल (ऐप में लॉग इन करने पर सेटिंग में मिलेगा):\n{{email}}\n\nऑर्डर नंबर (आमतौर पर खरीद के समय भेजे गए रसीद वाले ईमेल में मिलता है):\n\nक्या ऐसा हो सकता है कि उत्पाद असल में खरीदते समय किसी अलग नाम या ईमेल का इस्तेमाल किया गया हो? यदि हां, तो कृपया वे बताएं:\n\nपहला और अंतिम नाम:\n\nईमेल:",
		"contactSupport": "सहायता से संपर्क करें",
		"signOut": "साइन आउट करें",
		"signOutConfirmation": "क्या आप वाकई साइन आउट करना चाहते हैं?",
		"deleteAccount": "खाता हटाएं",
		"platform": "प्लेटफ़ॉर्म",
		"partnerships": "साझेदारी",
		"validUntil": "{{date}} को समाप्त होता है",
		"extendValidity": "पहुंच बढ़ाएं",
		"redeemPurchase": "खरीद रिडीम करें",
		"redeemPurchaseNoneFound": "रिडीम करने के लिए कोई खरीद उपलब्ध नहीं है",
		"redeemPurchaseCheckFailed": "खरीद जांची नहीं जा सकी। कृपया फिर से प्रयास करें।",
		"purchases": "खरीद",
		"frequentlyAskedQuestions": "अक्सर पूछे जाने वाले प्रश्न",
		"deleteFeedbackForm": {
			"placeholder": "फ़ीडबैक"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "अधिक डेटा चाहिए",
		"proficiencyLevelPendingTooltip": "अपने स्तर का अनुमान लगाने के लिए और {{label}} आइटम के उत्तर दें।",
		"on": "पर",
		"gotIt": "समझ गए",
		"goBack": "वापस जाएं",
		"topic": "विषय",
		"itemCount_one": "{{count, number}} आइटम",
		"itemCount_other": "{{count, number}} आइटम",
		"examCount_one": "{{count}} परीक्षा",
		"examCount_other": "{{count}} परीक्षाएं",
		"questionCount_one": "{{count}} प्रश्न",
		"questionCount_other": "{{count}} प्रश्न",
		"item_one": "आइटम",
		"item_other": "आइटम",
		"and": "और",
		"this": "यह",
		"of": "का",
		"knowMore": "अधिक जानें",
		"proficiency": "दक्षता",
		"didNotAnswer": "वे आइटम जिनका आपने अभी तक उत्तर नहीं दिया है।",
		"notAnswered": "अनुत्तरित",
		"attempted": "प्रयास किया",
		"attempt": "प्रयास",
		"activity": "गतिविधि",
		"performance": "प्रदर्शन",
		"estimatedProficiency": "अनुमानित दक्षता",
		"details": "विवरण",
		"keepPracticing": "अभ्यास जारी रखें!",
		"leaveFeedback": "फ़ीडबैक दें",
		"copiedToClipboard": "क्लिपबोर्ड पर कॉपी किया गया",
		"eg": "उदा.",
		"set": "सेट",
		"hint": "संकेत",
		"itemType": "आइटम प्रकार",
		"minute": "मिनट",
		"minutes": "{{count}} मिनट",
		"hour": "घंटा",
		"hours": "{{count}} घंटे",
		"continue": "जारी रखें",
		"unlock": "अनलॉक करें",
		"cancel": "रद्द करें",
		"view": "देखें",
		"switch": "बदलें",
		"update": "अपडेट करें",
		"ok": "ठीक है",
		"yes": "हां",
		"free": "मुफ़्त",
		"answered": "उत्तर दिया गया",
		"correct": "सही",
		"incorrect": "ग़लत",
		"marked": "चिह्नित",
		"unmarked": "चिह्नित नहीं",
		"skipped": "छोड़ा गया",
		"skill_one": "कौशल",
		"skill_other": "कौशल",
		"word_one": "शब्द",
		"word_other": "शब्द",
		"submitResponse": "प्रतिक्रिया सबमिट करें",
		"viewDetails": "विवरण देखें",
		"sec_one": "सेकंड",
		"sec_other": "सेकंड",
		"point_one": "अंक",
		"point_other": "अंक",
		"week": "सप्ताह",
		"month": "महीना",
		"year": "वर्ष",
		"day": "दिन",
		"selectTestDate": "परीक्षा की तारीख़ चुनें",
		"points": "अंक",
		"viewAll": "सभी देखें",
		"timeline": "टाइमलाइन",
		"save": "सेव करें",
		"filters": {
			"selectAll": "सभी चुनें",
			"deselectAll": "सभी को अचयनित करें",
			"selectedCount": "{{count}} चयनित",
			"expandSection": "{{section}} का विस्तार करें",
			"collapseSection": "{{section}} को संक्षिप्त करें"
		},
		"showMore": "और दिखाएं",
		"showLess": "कम दिखाएं",
		"expandA11yLabel": "विवरण का विस्तार करें",
		"collapseA11yLabel": "विवरण को संक्षिप्त करें",
		"done": "हो गया",
		"clearAll": "सभी साफ़ करें",
		"clear": "साफ़ करें",
		"datePicker": {
			"title": "तारीख़ चुनें",
			"enterDateLabel": "तारीख़ दर्ज करें",
			"enterDateRangeLabel": "तारीख़ें दर्ज करें",
			"dateLabel": "तारीख़",
			"startDateLabel": "शुरुआत की तारीख़",
			"endDateLabel": "समाप्ति की तारीख़",
			"dateRequiredError": "तारीख़ आवश्यक है",
			"invalidDateFormatError": "अमान्य तारीख़ प्रारूप। कृपया MM/DD/YYYY का उपयोग करें।",
			"startAfterEndError": "शुरुआत की तारीख़ समाप्ति की तारीख़ के बाद नहीं हो सकती।",
			"endBeforeStartError": "समाप्ति की तारीख़ शुरुआत की तारीख़ से पहले नहीं हो सकती।",
			"minDateError": "तारीख़ {{date}} या उसके बाद की होनी चाहिए।",
			"maxDateError": "तारीख़ {{date}} या उससे पहले की होनी चाहिए।",
			"dateRangeError": "तारीख़ {{startDate}} और {{endDate}} के बीच होनी चाहिए।",
			"setDateCta": "तारीख़ सेट करें",
			"nextCta": "अगला",
			"setTimeCta": "समय सेट करें"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} शिक्षार्थियों ने यह उत्तर चुना।",
		"choiceCorrectA11yLabel": "सही उत्तर",
		"choiceIncorrectA11yLabel": "ग़लत उत्तर",
		"choiceNotSelectedA11yLabel": "चयनित नहीं",
		"moreItemsAlertDialog": {
			"title": "अतिरिक्त आइटम",
			"cta": "समझ गए"
		},
		"results": {
			"followUps": {
				"title": "अनुवर्ती प्रश्न"
			},
			"summary": {
				"sessionAnalysis": "सत्र विश्लेषण",
				"itemCount_one": "{{count}} आइटम",
				"itemCount_other": "{{count}} आइटम",
				"skilledItemCount_one": "{{count}} {{skills}} आइटम",
				"skilledItemCount_other": "{{count}} {{skills}} आइटम",
				"levelPhrase_one": "{{levels}} स्तर से",
				"levelPhrase_other": "{{levels}} स्तरों से",
				"message": "<bold>शानदार काम!</bold> आपने अभी {{timeTaken}} में {{itemPhrase}} पूरा किया।",
				"messageWithLevels": "<bold>शानदार काम!</bold> आपने अभी {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) {{timeTaken}} में पूरा किया।",
				"proficiencyEstimateReady": "आपका अनुमानित {{skill}} स्तर <bold>{{currentLevel}}</bold> है। अब आप <bold>{{nextLevel}}</bold> को लक्ष्य बनाने के लिए तैयार हैं।",
				"proficiencyEstimateKeepPracticing": "आपका अनुमानित {{skill}} स्तर <bold>{{currentLevel}}</bold> है। <bold>{{nextLevel}}</bold> पर आगे बढ़ने से पहले अभ्यास जारी रखें।",
				"proficiencyEstimateHighest": "आपका अनुमानित {{skill}} स्तर <bold>{{currentLevel}}</bold> है। शानदार प्रदर्शन!",
				"mixedLevel": "मिश्रित",
				"overallScore": "समग्र स्कोर",
				"stats": {
					"itemsAttempted_one": "उत्तर दिया गया आइटम",
					"itemsAttempted_other": "उत्तर दिए गए आइटम",
					"pointsEarned_one": "अर्जित अंक",
					"pointsEarned_other": "अर्जित अंक",
					"answeredCorrectly": "सही उत्तर दिया",
					"timeTaken": "लिया गया समय",
					"target": "लक्ष्य",
					"ofTotal": "{{total}} में से",
					"ofPointsTotal": "{{total}} में से",
					"skill": "कौशल",
					"skills": "कौशल",
					"questionType": "प्रश्न प्रकार",
					"questionTypes": "प्रश्न प्रकार",
					"proficiencyLevel": "दक्षता स्तर",
					"proficiencyLevels": "दक्षता स्तर"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "ऑडियो {{seconds}} सेकंड में शुरू होगा",
			"audioStartsInPlayOnce": "ऑडियो {{seconds}} सेकंड में शुरू होगा, केवल एक बार चलेगा",
			"videoStartsIn": "वीडियो {{seconds}} सेकंड में शुरू होगा",
			"videoStartsInPlayOnce": "वीडियो {{seconds}} सेकंड में शुरू होगा, केवल एक बार चलेगा",
			"recordingIn": "रिकॉर्डिंग {{seconds}} सेकंड में शुरू होगी"
		},
		"timeOverrunBanner": {
			"message": "समय समाप्त। वास्तविक परीक्षा में, इसके बाद कुछ भी स्कोर नहीं किया जाएगा। आप अभ्यास जारी रख सकते हैं।"
		},
		"attributes": {
			"stimulus": "उद्दीपक"
		},
		"stimulusTypes": {
			"reading": "रीडिंग",
			"listening": "लिसनिंग",
			"speaking": "स्पीकिंग",
			"writing": "राइटिंग",
			"image": "छवि"
		},
		"masteryLevels": {
			"belowBasic": "प्रारंभिक से कम",
			"basic": "प्रारंभिक",
			"belowLowIntermediate": "निम्न-मध्यवर्ती से कम",
			"lowIntermediate": "निम्न-मध्यवर्ती",
			"highIntermediate": "उच्च-मध्यवर्ती",
			"advanced": "उन्नत",
			"proficiencySubtitle": "{{trademark}} पर, यह **{{minScore}}-{{maxScore}}/30** के स्कोर के अनुरूप है",
			"infoSectionLabel": "{{skill}} अनुभाग जानकारी",
			"infoSectionText": {
				"Reading": "{{trademark}} रीडिंग अनुभाग यह आकलन करता है कि आप शैक्षणिक परिवेश में इस्तेमाल होने वाली लिखित सामग्री को कितनी अच्छी तरह पढ़ और समझ सकते हैं। इसमें दो गद्यांश शामिल हैं, प्रत्येक लगभग 700 शब्दों का, जिसमें प्रति गद्यांश 10 प्रश्न होते हैं। रीडिंग अनुभाग पूरा करने में लगभग 35 मिनट लगते हैं।",
				"Listening": "{{trademark}} लिसनिंग अनुभाग को अंग्रेज़ी में बातचीत और व्याख्यान समझने की आपकी क्षमता मापने के लिए डिज़ाइन किया गया है। इसमें शामिल है: बुनियादी समझ, वक्ता के दृष्टिकोण और निश्चितता के स्तर को समझना, और जानकारी को जोड़ना। लिसनिंग अनुभाग पूरा करने में लगभग 36 मिनट लगते हैं।",
				"Speaking": "{{trademark}} स्पीकिंग अनुभाग शैक्षणिक परिवेश में प्रभावी ढंग से अंग्रेज़ी बोलने की आपकी क्षमता मापता है। चारों प्रश्न/कार्य वास्तविक जीवन की उन स्थितियों जैसे होते हैं जिनका सामना आप कक्षा के अंदर और बाहर दोनों जगह कर सकते हैं। स्पीकिंग अनुभाग पूरा करने में लगभग 16 मिनट लगते हैं।",
				"Writing": "{{trademark}} राइटिंग अनुभाग शैक्षणिक परिवेश में अंग्रेज़ी में लिखने और अपने विचारों को स्पष्ट, सुव्यवस्थित तरीके से प्रस्तुत करने की आपकी क्षमता मापता है। आप अपनी प्रतिक्रियाएं कंप्यूटर कीबोर्ड पर टाइप करेंगे और राइटिंग अनुभाग पूरा करने में लगभग 29 मिनट लगते हैं।"
			}
		},
		"itemTypes": {
			"MCSS": "बहुविकल्पीय एकल चयन",
			"MCSSH": "बहुविकल्पीय एकल चयन हाइलाइट",
			"MCMS": "बहुविकल्पीय बहु चयन",
			"MCMSH": "बहुविकल्पीय बहु चयन हाइलाइट",
			"INSERT_TEXT": "टेक्स्ट सम्मिलित करें",
			"MATCH_MS": "मिलान बहु चयन",
			"MCSSM": "बहुविकल्पीय एकल चयन मिलान",
			"MCMSM": "बहुविकल्पीय बहु चयन मिलान",
			"MCGS": "बहुविकल्पीय रिक्त स्थान चयन",
			"MCOS": "बहुविकल्पीय क्रम चयन",
			"LISTENING_REPLAY": "लिसनिंग रीप्ले",
			"AUDIO_INPUT": "ऑडियो इनपुट",
			"ACADEMIC_DISCUSSION_RESPONSE": "शैक्षणिक चर्चा प्रतिक्रिया",
			"INTEGRATED_WRITING_RESPONSE": "एकीकृत राइटिंग प्रतिक्रिया"
		},
		"passageStem": {
			"itemOfTotal": "{{total}} में से आइटम {{current}}",
			"questionOfTotal": "{{total}} में से प्रश्न {{current}}",
			"stimulusCorrespondsToNextItems": "निम्नलिखित उद्दीपक अगले {{total}} आइटम से संबंधित है",
			"passage": "गद्यांश",
			"lecture": "व्याख्यान",
			"professorsQuestion": "प्रोफेसर का प्रश्न",
			"listen": "सुनें",
			"openPassage": "गद्यांश खोलें",
			"backToItem": "आइटम पर वापस जाएं",
			"notYetInserted": "अभी तक सम्मिलित नहीं",
			"insertedAtPosition": "स्थिति #{{position}} पर सम्मिलित"
		},
		"hint": {
			"show": "संकेत दिखाएं"
		},
		"navigation": {
			"next": "अगला",
			"exit": "बाहर निकलें",
			"saveAndExit": "सेव करें और बाहर निकलें",
			"previous": "पिछला",
			"skip": "छोड़ें",
			"finish": "समाप्त करें",
			"help": "सहायता",
			"about": "प्रश्न सुझाव",
			"questionsButtonLabel": "प्रश्न नेविगेशन",
			"questionsButtonTooltip": "किसी भी प्रश्न पर जाएं या चिह्नित प्रश्नों की समीक्षा करें।",
			"questionsButtonActiveFiltersA11y": "सक्रिय फ़िल्टर: {{count}}",
			"recordingInProgressTooltip": "जब तक रिकॉर्डिंग जारी है, आप इस आइटम से बाहर नहीं जा सकते।",
			"questionNotReachedTooltip": "आप अभी तक इस प्रश्न तक नहीं पहुंचे हैं।"
		},
		"questionTips": {
			"hideFutureLabel": "सुझाव अपने आप न दिखाएं"
		},
		"toolbar": {
			"calculatorTooltip": "कैलकुलेटर खोलें",
			"highlightTooltip": "आसान संदर्भ के लिए महत्वपूर्ण जानकारी को हाइलाइट करने हेतु टेक्स्ट चुनें।",
			"markTooltip": "सबमिट करने से पहले बाद में दोबारा देखने के लिए इस प्रश्न को चिह्नित करें।",
			"unmarkTooltip": "इस प्रश्न को अचिह्नित करने के लिए क्लिक करें।"
		},
		"summary": {
			"viewFullInsights": "पूरी इनसाइट देखें",
			"targetTooltip": "इस सत्र के लिए प्रदर्शन लक्ष्य।"
		},
		"stats": {
			"skill": "कौशल",
			"answered": "उत्तर दिया गया",
			"speed": "गति",
			"duration": "अवधि",
			"duration_tooltip": "आपकी रिकॉर्ड की गई प्रतिक्रिया की अवधि: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "आत्मविश्वास",
			"pointsEarned": "अंक",
			"word": "शब्द",
			"words": "शब्द",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "इस आइटम को पढ़ने और उसका उत्तर देने में आपको {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) का समय लगा",
			"skill_tooltip": "इस आइटम के लिए आंका गया कौशल क्षेत्र: {{skill}}",
			"answered_correct_tooltip": "आपकी सबमिट की गई प्रतिक्रिया सही थी",
			"answered_incorrect_tooltip": "आपकी सबमिट की गई प्रतिक्रिया ग़लत थी",
			"skipped_tooltip": "आपने इस आइटम के लिए कोई प्रतिक्रिया सबमिट नहीं की",
			"words_tooltip": "आपकी लिखित प्रतिक्रिया में शब्दों की संख्या: {{count}}",
			"word_tooltip": "आपकी लिखित प्रतिक्रिया में शब्दों की संख्या: {{count}}",
			"confidence_tooltip": "आपने अपनी प्रतिक्रिया सबमिट करते समय कितना आत्मविश्वास महसूस किया",
			"points_earned_tooltip_one": "आपको इस आइटम के लिए अधिकतम {{maximumScore}} अंकों में से {{points}} अंक मिला",
			"points_earned_tooltip_other": "आपको इस आइटम के लिए अधिकतम {{maximumScore}} अंकों में से {{points}} अंक मिले",
			"challengers_tooltip": "आपसे पहले इस आइटम का उत्तर देने वाले शिक्षार्थियों की संख्या: {{count}}",
			"learning_mode_points_tooltip": "इस प्रयास के लिए अर्जित अंक: +{{xp}} XP",
			"pts_earned_tooltip": "इस प्रयास के लिए अर्जित अंक: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "ब्यौरे का विस्तार करें"
		},
		"explanation": {
			"title": "व्याख्या",
			"feedback": "फ़ीडबैक",
			"skippedFeedbackNotice": "आपने इस प्रश्न को छोड़ दिया, इसलिए व्यक्तिगत फ़ीडबैक तैयार नहीं किया गया।"
		},
		"followUps": "अनुवर्ती प्रश्न",
		"suggestCorrection": "सुधार सुझाएं",
		"answer": {
			"correct": "सही",
			"incorrect": "ग़लत",
			"skipped": "छोड़ा गया"
		},
		"confidence": {
			"high": "उच्च",
			"medium": "मध्यम",
			"low": "निम्न"
		},
		"endDialog": {
			"title": "सत्र जल्दी समाप्त करें?",
			"confirmEndDiagnostic": "क्या आप वाकई अपना सत्र समाप्त करना चाहते हैं? सारी प्रगति खो जाएगी और आपको फिर से शुरू करना होगा।",
			"confirmEnd": "आपके पास अभी भी {{num}} {{itemLabel}} बाकी हैं। आप अभी समाप्त कर सकते हैं या उन्हें पूरा करने के लिए अध्ययन जारी रख सकते हैं।",
			"confirmEndNoAnswer": "आपने अभी तक किसी भी प्रश्न का उत्तर नहीं दिया है। क्या आप वाकई अभी समाप्त करना चाहते हैं?",
			"confirmEndNoAnswerPositive": "अध्ययन जारी रखें",
			"confirmEndNoAnswerNegative": "अभी समाप्त करें"
		},
		"permissionDialog": {
			"title": "माइक्रोफ़ोन एक्सेस चाहिए",
			"descriptionWeb": "स्पीकिंग अभ्यास आपके माइक्रोफ़ोन का उपयोग करता है। आपका ब्राउज़र इस साइट के लिए एक्सेस को ब्लॉक कर रहा है — वेब पते के बगल में अनुमति आइकन पर क्लिक करें, माइक्रोफ़ोन को अनुमति दें, फिर दोबारा प्रयास करें।",
			"descriptionMobile": "स्पीकिंग अभ्यास आपके माइक्रोफ़ोन का उपयोग करता है। जारी रखने के लिए अपनी डिवाइस सेटिंग में माइक्रोफ़ोन एक्सेस की अनुमति दें।",
			"promptDescriptionWeb": "स्पीकिंग अभ्यास आपके माइक्रोफ़ोन का उपयोग करता है। अनुमति का अनुरोध करें और जब आपका ब्राउज़र पूछे तो अनुमति दें चुनें।",
			"blockedDescriptionWeb": "इस साइट के लिए माइक्रोफ़ोन एक्सेस ब्लॉक है। वेब पते के बगल में आइकन पर क्लिक करें, माइक्रोफ़ोन को अनुमति दें, फिर दोबारा अनुमति का अनुरोध करें।",
			"ok": "ठीक है",
			"cancel": "रद्द करें",
			"openSettings": "सेटिंग खोलें",
			"requestPermission": "अनुमति का अनुरोध करें",
			"dismissAndExit": "खारिज करें और बाहर निकलें",
			"learnMore": "अधिक जानें"
		},
		"audioPlaybackTestDialog": {
			"title": "ऑडियो प्लेबैक टेस्ट करें",
			"description": "{{appName}} ऐप में कई ऑडियो प्लेबैक सुविधाएं शामिल हैं, जैसे उद्दीपकों, टेस्ट आइटम और टेक्स्ट-टू-स्पीच में मौजूद सुविधाएं। सर्वोत्तम अनुभव सुनिश्चित करने के लिए, कृपया नीचे अपना ऑडियो टेस्ट करें। इसके काम करने की पुष्टि हो जाने पर, आगे बढ़ें।",
			"troubleshooting": {
				"title": "ऑडियो समस्याओं का निवारण",
				"volumeTitle": "डिवाइस का वॉल्यूम जांचें",
				"volumeDescriptionWeb": "मेनू/टास्कबार में कीबोर्ड नियंत्रण या सिस्टम वॉल्यूम सेटिंग का उपयोग करके वॉल्यूम समायोजित करें",
				"volumeDescriptionMobile": "डिवाइस के वॉल्यूम बटन का उपयोग करें या सिस्टम सेटिंग में समायोजित करें",
				"outputTitle": "ऑडियो आउटपुट डिवाइस सत्यापित करें",
				"outputDescription": "हेडफ़ोन के मामले में, सुनिश्चित करें कि वे ठीक से कनेक्ट हैं और सक्रिय आउटपुट डिवाइस के रूप में चयनित हैं",
				"browserTitle": "ब्राउज़र टैब का ऑडियो जांचें",
				"browserDescription": "टैब शीर्षक के बगल में म्यूट किए गए स्पीकर आइकन को देखें और यदि मौजूद हो तो अनम्यूट करें।"
			},
			"skipCheck": "अगली बार यह जांच छोड़ें",
			"workingButton": "ऑडियो की पुष्टि करें",
			"textToHear": "आपको यह सुनाई देना चाहिए: {{text}}"
		},
		"overall": "समग्र",
		"subskills": {
			"content": {
				"title": "सामग्री"
			},
			"languageUse": {
				"title": "भाषा प्रयोग"
			},
			"organizationAndDevelopment": {
				"title": "संगठन और विकास"
			},
			"topicDevelopment": {
				"title": "विषय विकास"
			},
			"delivery": {
				"title": "प्रस्तुति"
			}
		},
		"finalizing": {
			"title": "आपके परिणाम को अंतिम रूप दिया जा रहा है",
			"gradingProgress": "प्रतिक्रियाओं का मूल्यांकन किया जा रहा है..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "एक स्पीकिंग कार्य जिसमें शिक्षार्थी सुने गए वाक्य को यथासंभव सटीकता से दोहराता है।",
			"Read Aloud": "एक स्पीकिंग आइटम जिसमें शिक्षार्थी मूल्यांकन के लिए एक गद्यांश को ज़ोर से पढ़ता है।",
			"Describe Image": "एक स्पीकिंग कार्य जिसमें शिक्षार्थी एक दृश्य उद्दीपक का विस्तार से वर्णन करता है।",
			"Write Essay": "एक लेखित-प्रतिक्रिया कार्य जिसमें दिए गए विषय पर एक संरचित निबंध लिखना ज़रूरी है।",
			"Retell Lecture": "एक स्पीकिंग कार्य जिसमें शिक्षार्थी सुने गए व्याख्यान या वार्ता का सारांश देता है।",
			"Summarize Group Discussion": "एक लिसनिंग कार्य जिसमें शिक्षार्थी एक बहु-वक्ता चर्चा का सारांश देता है।",
			"Answer Short Question": "एक संक्षिप्त स्पीकिंग कार्य जिसमें शिक्षार्थी एक संक्षिप्त प्रतिक्रिया के साथ किसी एक छोटे प्रश्न का उत्तर देता है।",
			"Respond to a Situation": "एक स्पीकिंग कार्य जिसमें शिक्षार्थी वर्णित परिदृश्य पर उचित प्रतिक्रिया देता है।",
			"Summarize Written Text": "एक रीडिंग कार्य जिसमें शिक्षार्थी अपने शब्दों में एक गद्यांश का सारांश देता है।",
			"Reorder Paragraph": "एक रीडिंग कार्य जिसमें शिक्षार्थी बिखरे हुए अनुच्छेदों को सही क्रम में व्यवस्थित करता है।",
			"Fill in the Blanks (Dropdown)": "एक रीडिंग कार्य जिसमें प्रत्येक रिक्त स्थान को विकल्पों की एक ड्रॉपडाउन सूची से पूरा किया जाता है।",
			"Fill in the Blanks (Type In)": "एक लिसनिंग कार्य जिसमें शिक्षार्थी छूटे हुए शब्द या छोटे वाक्यांश को टाइप करता है।",
			"Fill in the Blanks (Drag and Drop)": "एक रीडिंग कार्य जिसमें विकल्पों को रिक्त स्थानों में खींचकर छूटे हुए शब्द भरे जाते हैं।",
			"Multiple Choice, Single Answer": "एक बहुविकल्पीय आइटम जिसमें शिक्षार्थी एक सही उत्तर चुनता है।",
			"Multiple Choice, Single Answer (Reading)": "एक रीडिंग बहुविकल्पीय आइटम जिसमें शिक्षार्थी एक सही उत्तर चुनता है।",
			"Multiple Choice, Single Answer (Listening)": "एक लिसनिंग बहुविकल्पीय आइटम जिसमें शिक्षार्थी एक सही उत्तर चुनता है।",
			"Multiple Choice, Multiple Answers": "एक आइटम जिसमें शिक्षार्थी एक से अधिक सही उत्तर चुन सकता है।",
			"Multiple Choice, Multiple Answers (Reading)": "एक रीडिंग आइटम जिसमें शिक्षार्थी एक से अधिक सही उत्तर चुन सकता है।",
			"Multiple Choice, Multiple Answers (Listening)": "एक लिसनिंग आइटम जिसमें शिक्षार्थी एक से अधिक सही उत्तर चुन सकता है।",
			"Summarize Spoken Text": "एक लिसनिंग कार्य जिसमें शिक्षार्थी जो सुना उसका सारांश लिखता है।",
			"Highlight Correct Summary": "एक लिसनिंग कार्य जिसमें शिक्षार्थी उस सारांश को हाइलाइट करता है जो ऑडियो से सबसे अच्छी तरह मेल खाता है।",
			"Select Missing Word": "एक क्लोज़-शैली का लिसनिंग कार्य जिसमें शिक्षार्थी छूटे हुए शब्द को चुनता है।",
			"Highlight Incorrect Words": "एक लिसनिंग कार्य जिसमें शिक्षार्थी ट्रांसक्रिप्ट में उन शब्दों को हाइलाइट करता है जो ऑडियो से भिन्न हैं।",
			"Write from Dictation": "एक लिसनिंग कार्य जिसमें शिक्षार्थी सुने गए वाक्य को लिखकर उतारता है।"
		}
	},
	"report": {
		"readFullInsights": "पूरी इनसाइट पढ़ें",
		"productName": "{{examName}} {{type}}",
		"startedAt": "{{time}} पर शुरू हुआ",
		"itemTypesTitle": "आइटम प्रकार का विवरण",
		"itemTypesFilterAll": "सभी",
		"questionTypeCardTitle": "{{skill}} आइटम प्रकार का विवरण",
		"questionTypeCardSubtitle_one": "इस सत्र में {{count}} {{skill}} आइटम प्रकार के आधार पर",
		"questionTypeCardSubtitle_other": "इस सत्र में {{count}} {{skill}} आइटम प्रकार के आधार पर",
		"questionTypeCardAltSubtitle_one": "इस सत्र में {{count}} आइटम प्रकार के आधार पर",
		"questionTypeCardAltSubtitle_other": "इस सत्र में {{count}} आइटम प्रकार के आधार पर",
		"questionTypeRowSubtitle_zero": "किसी आइटम का उत्तर नहीं दिया गया",
		"questionTypeRowSubtitle_one": "{{count}} आइटम का उत्तर दिया गया",
		"questionTypeRowSubtitle_other": "{{count}} आइटम का उत्तर दिया गया",
		"itemTypeDetail": {
			"review_one": "आइटम की समीक्षा करें",
			"review_other": "आइटम की समीक्षा करें",
			"stats": {
				"answered_one": "आइटम का उत्तर दिया गया",
				"answered_other": "आइटम का उत्तर दिया गया",
				"avgTime": "प्रति आइटम औसत समय"
			}
		},
		"reviewAnswersDialog": {
			"title": "उत्तरों की समीक्षा",
			"sections": {
				"skills": "कौशल",
				"questionTypes": "प्रश्न प्रकार",
				"proficiency": "दक्षता",
				"performance": "प्रदर्शन"
			},
			"summaryNone": "जारी रखने के लिए आइटम वाले फ़िल्टर चुनें।",
			"summaryAll_one": "सभी {{count}} उत्तर की समीक्षा करें।",
			"summaryAll_other": "सभी {{count}} उत्तरों की समीक्षा करें।",
			"summaryFiltered_one": "{{filters}} से मेल खाने वाले {{count}} उत्तर की समीक्षा करें।",
			"summaryFiltered_other": "{{filters}} से मेल खाने वाले {{count}} उत्तरों की समीक्षा करें।",
			"reviewAnswers_one": "{{count}} उत्तर की समीक्षा करें",
			"reviewAnswers_other": "{{count}} उत्तरों की समीक्षा करें",
			"more": "{{count}} और"
		},
		"itemDetail": {
			"title": "मेरे उत्तरों की समीक्षा करें",
			"filterAll": "सभी",
			"filterCorrect": "सही",
			"filterIncorrect": "ग़लत",
			"filterMarked": "चिह्नित",
			"emptyTitle": "कोई मेल खाने वाला आइटम नहीं",
			"emptyDescription": "आपके सत्र के किसी भी आइटम से चयनित फ़िल्टर ({{filter}}) मेल नहीं खाता। अधिक परिणाम देखने के लिए फ़िल्टर समायोजित करें या साफ़ करें।",
			"emptyCta": "फ़िल्टर साफ़ करें"
		},
		"answerCardTitle": "उत्तर दिए गए आइटम",
		"answerCardSubtitle_one": "देखें कि आपने सभी प्रश्नों में कैसा प्रदर्शन किया",
		"answerCardSubtitle_other": "देखें कि आपने सभी {{count}} प्रश्नों में कैसा प्रदर्शन किया",
		"skillsBreakdown": {
			"title": "कौशल का विवरण",
			"subtitle_one": "{{count}} आइटम के आधार पर",
			"subtitle_other": "{{count}} आइटम के आधार पर"
		},
		"studyPack": "स्टडी-पैक",
		"practiceTestCompleted": "प्रैक्टिस टेस्ट पूर्ण हुआ",
		"studySessionCompleted": "अध्ययन सत्र पूर्ण हुआ",
		"diagnosticSessionCompleted": "डायग्नोस्टिक सत्र पूर्ण हुआ",
		"timeElapsed": "बीता हुआ समय",
		"stats": {
			"answered": "उत्तर दिया गया",
			"time elapsed": "बीता हुआ समय",
			"avg speed": "औसत गति",
			"hints used": "प्रयुक्त संकेत"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "शानदार काम—उत्कृष्टता के लिए प्रयास करते रहें!",
				"highIntermediate": "आप बहुत अच्छा कर रहे हैं—अपनी ताकत निखारते रहें!",
				"lowIntermediate": "आपकी प्रगति स्थिर है—इसे जारी रखें!",
				"basic": "अपनी क्षमताओं को बढ़ाने के लिए काम करते रहें!"
			},
			"infoText": "आपने अपने {{skillsText}} {{skills}} का अभ्यास करने के लिए **{{numActivities}} {{activityLabel}}** पूरे किए। {{skillDetails}}। कुल मिलाकर, आपने **{{numTotalPoints}} में से {{numPointsEarned}} अंक** अर्जित किए, जो {{thisText}} {{skills}} में **{{compositeLevel}} दक्षता** दर्शाता है। {{compositeFeedback}}",
			"infoText.singleSkill": "आपने अपने **{{skill_1}}** कौशल पर केंद्रित **{{itemCount}} {{itemLabel}}** पूरे किए। आपने **{{skill_1_total}} में से {{skill_1_score}}** अंक प्राप्त किए, जो **{{proficiency}} दक्षता** को दर्शाता है। {{compositeFeedback}}",
			"infoText.multiSkill": "आपने अपने **{{skills_text}}** कौशल का अभ्यास करते हुए **{{itemCount}} {{itemLabel}}** पूरे किए। {{skill_details}} कुल मिलाकर, आपने **{{overall_total}} में से {{overall_score}} अंक** अर्जित किए, जो इन कौशलों में **{{overall_proficiency}} दक्षता** दर्शाता है। {{compositeFeedback}}",
			"skillDetails": "**{{skill}}** में, आपने **{{total}} में से {{score}}** अंक प्राप्त किए, जो **{{proficiency}} दक्षता** दर्शाता है।"
		},
		"actions": {
			"goToHome": "होम पर जाएं",
			"studyMore": "अधिक अध्ययन करें",
			"studyFree": "मुफ़्त {{tagTypes}} का अध्ययन करें",
			"reviewAnswers": "उत्तरों की समीक्षा करें"
		},
		"nextAction": {
			"title": "अनुशंसित: {{focus}} अभ्यास",
			"dialog": {
				"title": "अनुशंसित अध्ययन सत्र",
				"subtitle": "अपने कमज़ोर क्षेत्रों पर ध्यान दें"
			},
			"fallback": {
				"title": "अभ्यास जारी रखें",
				"description": "उन क्षेत्रों के आधार पर एक अध्ययन सत्र बनाएं जिन पर आप आगे काम करना चाहते हैं।"
			}
		},
		"premium": {
			"upgradeCta": "प्रीमियम में अपग्रेड करें"
		},
		"disclaimer": {
			"title": "अस्वीकरण",
			"summativeBody": "प्रैक्टिस टेस्ट स्कोर एक अनुमान है और लाइव {{examName}} परीक्षा में समान परिणाम की गारंटी नहीं देता।"
		},
		"performance": {
			"title": "प्रदर्शन",
			"subtitle": "{{count}} आइटम के आधार पर",
			"correct": "सही",
			"correctItems": "{{count}} आइटम",
			"incorrect": "ग़लत",
			"incorrectItems": "{{count}} आइटम"
		},
		"mastery": {
			"performanceTitle": "प्रदर्शन",
			"sessionMasteryTitle": "अनुमानित दक्षता",
			"subtitle_assessment": "इस मूल्यांकन के सभी {{count}} {{item}} के आधार पर",
			"subtitle_session": "इस सत्र के सभी {{count}} {{item}} के आधार पर"
		},
		"sessionAnalysis": {
			"title": "सत्र विश्लेषण",
			"subtitle": "व्यक्तिगत विश्लेषण और सिफ़ारिशें",
			"viewFullAnalysis": "विश्लेषण देखें",
			"feedbackDialog": {
				"body": "हम लगभग हर दिन अपडेट जारी करते हैं और बेहतर बनने के लिए प्रतिबद्ध हैं। क्या आप फ़ीडबैक दे सकते हैं?",
				"placeholder": "यहां अपना फ़ीडबैक दर्ज करें",
				"cta": "फ़ीडबैक भेजें",
				"successMessage": "फ़ीडबैक सबमिट किया गया। धन्यवाद!",
				"feedbackLimitError": "फ़ीडबैक कम से कम 10 अक्षर लंबा होना चाहिए।"
			},
			"menuActions": {
				"copy": "कॉपी करें",
				"altCopy": "सारांश टेक्स्ट कॉपी करें",
				"altPositiveFeedback": "यह सहायक था",
				"positiveFeedback": "अच्छी प्रतिक्रिया",
				"negativeFeedback": "खराब प्रतिक्रिया",
				"reportIssue": "रिपोर्ट करें",
				"altReportIssue": "इस प्रतिक्रिया की रिपोर्ट करें",
				"emailSummary": "सारांश टेक्स्ट ईमेल करें",
				"emailAlreadySent": "ईमेल पहले ही भेजा जा चुका है",
				"copiedAnalysis": "विश्लेषण क्लिपबोर्ड पर कॉपी किया गया",
				"emailSent": "{{email}} पर ईमेल भेजा गया। यदि आपको ईमेल न मिले, तो अपने जंक, स्पैम और हाल ही में हटाए गए फ़ोल्डर देखें।",
				"emailFailed": "{{email}} पर ईमेल भेजने में विफल रहा।",
				"emailInstructionMessage": "यदि आपको ईमेल न मिले, तो अपने जंक, स्पैम और हाल ही में हटाए गए फ़ोल्डर देखें, या अपने आईटी प्रशासक से संपर्क करें।"
			}
		}
	},
	"feedback": {
		"successMessage": "फ़ीडबैक सबमिट किया गया। धन्यवाद!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "आपको क्या पसंद है? किसमें सुधार किया जा सकता है? हम प्लेटफ़ॉर्म में रोज़ाना सुधार करते हैं और हमारी टीम हर फ़ीडबैक पढ़ती है। धन्यवाद!",
			"title": "अपना फ़ीडबैक साझा करें",
			"body": "आपको क्या पसंद है? किसमें सुधार किया जा सकता है? हम प्लेटफ़ॉर्म में रोज़ाना सुधार करते हैं और हमारी टीम हर फ़ीडबैक पढ़ती है। **धन्यवाद!**",
			"positiveBody": "हमें खुशी है कि यह सहायक रहा! हमें बताएं **कि आपको क्या पसंद आया।**",
			"negativeBody": "हमें यह समझने में मदद करें कि क्या ग़लत हुआ ताकि हम **अपनी प्रतिक्रियाओं में सुधार कर सकें।**",
			"placeholder": "फ़ीडबैक दर्ज करें",
			"cta": "फ़ीडबैक भेजें"
		},
		"report": {
			"title": "रिपोर्ट सबमिट करें",
			"body": "हमें यह समझने में मदद करें कि इस प्रतिक्रिया में क्या ग़लत है।",
			"cta": "रिपोर्ट सबमिट करें"
		},
		"suggestCorrection": {
			"title": "सुधार सुझाएं",
			"body": "**किसी भी त्रुटि की रिपोर्ट करके** इस सामग्री की सटीकता सुधारने में हमारी मदद करें।",
			"cta": "सबमिट करें"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "ग़लत",
					"description": "प्रतिक्रिया में ग़लत जानकारी है।"
				},
				"notHelpful": {
					"title": "सहायक नहीं",
					"description": "प्रतिक्रिया ने मेरे प्रश्न का समाधान नहीं किया।"
				},
				"incomplete": {
					"title": "अधूरा",
					"description": "प्रतिक्रिया में महत्वपूर्ण विवरण छूट गए हैं।"
				},
				"hardToUnderstand": {
					"title": "समझना मुश्किल",
					"description": "प्रतिक्रिया भ्रामक या अस्पष्ट थी।"
				},
				"other": {
					"title": "अन्य",
					"description": "कुछ और"
				}
			},
			"report": {
				"misinformation": {
					"title": "ग़लत सूचना",
					"description": "प्रतिक्रिया में झूठी या भ्रामक जानकारी है।"
				},
				"harmfulContent": {
					"title": "हानिकारक या आपत्तिजनक सामग्री",
					"description": "घृणास्पद भाषण, उत्पीड़न, या अनुचित भाषा"
				},
				"violatesPolicies": {
					"title": "नीतियों का उल्लंघन",
					"description": "स्पैम, स्व-प्रचार, या अवैध सामग्री"
				},
				"other": {
					"title": "अन्य",
					"description": "अपने शब्दों में बताएं कि क्या ग़लत हुआ।"
				}
			}
		},
		"faqs": {
			"title": "अक्सर पूछे जाने वाले प्रश्न",
			"body": "यहां ऐप के बारे में सबसे अधिक पूछे जाने वाले कुछ प्रश्न दिए गए हैं। यदि आपके कोई अन्य प्रश्न हैं, तो कृपया हमसे support@memorang.ai पर संपर्क करें।"
		},
		"delete": {
			"title": "खाता हटाएं",
			"body": "हमें आपको जाते देख दुख हो रहा है, और हम आपके शैक्षणिक व व्यावसायिक सफर के लिए शुभकामनाएं देते हैं!",
			"options": "बहुत महंगा|मैंने अपना टेस्ट पहले ही दे दिया|सामग्री पसंद नहीं आई|सुविधाएं/कार्यक्षमता की कमी|अन्य",
			"confirmdelete": {
				"title": "खाता हटाने की पुष्टि करें",
				"cta": "हटाएं",
				"errorMessage": "क्षमा करें, वह ईमेल इस खाते से मेल नहीं खाता। कृपया फिर से प्रयास करें।",
				"successMessage": "खाता सफलतापूर्वक हटाया गया!",
				"validEmail": "कृपया एक मान्य ईमेल पता दर्ज करें।"
			}
		}
	},
	"recorder": {
		"tapToRecord": "अपनी प्रतिक्रिया रिकॉर्ड करने के लिए टैप करें।",
		"responseAudioUnavailable": "प्रतिक्रिया ऑडियो प्लेबैक के लिए उपलब्ध नहीं है।",
		"recording": "रिकॉर्डिंग",
		"recordingCompleted": "रिकॉर्डिंग पूर्ण",
		"getReady": "तैयार हो जाएं",
		"timeIsUp": "समय समाप्त। आपकी प्रतिक्रिया रिकॉर्ड नहीं की गई।",
		"alert": {
			"title": "अधिकतम अवधि पूरी हुई",
			"body": "रिकॉर्डिंग रोक दी गई है क्योंकि यह {{maxDuration}} सेकंड की अधिकतम अवधि तक पहुंच गई है।"
		},
		"uiElementPressed": "रिकॉर्डिंग रोकी गई - सक्रिय रिकॉर्डिंग के दौरान उद्दीपक खोला गया।"
	},
	"writing": {
		"placeholder": "अपनी प्रतिक्रिया यहां लिखें...",
		"wordCount": "{{count}} {{word}}",
		"title": "आपकी प्रतिक्रिया",
		"submit": "सबमिट करें",
		"helper": {
			"range": "अपनी प्रतिक्रिया सबमिट करने के लिए {{min}}–{{max}} शब्द लिखें।",
			"min": "अपनी प्रतिक्रिया सबमिट करने के लिए कम से कम {{min}} शब्द लिखें।",
			"max": "अपनी प्रतिक्रिया को {{max}} शब्द या उससे कम करें।"
		}
	},
	"navbar": {
		"home": "होम",
		"progress": "प्रगति",
		"insights": "इनसाइट",
		"leaderboard": "लीडर्स",
		"store": "स्टोर",
		"more": "और",
		"redeem": "रिडीम करें",
		"study-pack": "स्टडी-पैक",
		"podcasts": "पॉडकास्ट",
		"modules": "मॉड्यूल",
		"account": "खाता सेटिंग",
		"accountTab": "खाता",
		"privacy": "गोपनीयता",
		"terms": "शर्तें",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "कोड सही ढंग से दर्ज किया और फिर भी समस्या हो रही है? **सहायता से संपर्क करें** और अपना एक्सेस कोड व खरीद विवरण शामिल करना न भूलें",
		"olxDialog": {
			"unlockedTitle": "एक्सेस अनलॉक हुआ",
			"expiredTitle": "एक्सेस समाप्त हो गया",
			"testInfo": "**परीक्षा:** {{examName}} | **टेस्ट:** {{bundleName}}",
			"upcomingBody_one": "OLX टेस्ट तक आपकी पहुँच अनलॉक हो गई है!\n\nआप अपना सत्र **{{count}} दिन** में शुरू कर सकते हैं। प्रैक्टिस टेस्ट टैब से अपना सत्र शुरू करने के लिए बाद में फिर से देखें।",
			"upcomingBody_other": "OLX टेस्ट तक आपकी पहुँच अनलॉक हो गई है!\n\nआप अपना सत्र **{{count}} दिनों** में शुरू कर सकते हैं। प्रैक्टिस टेस्ट टैब से अपना सत्र शुरू करने के लिए बाद में फिर से देखें।",
			"activeBody": "OLX टेस्ट तक आपकी पहुँच अब सक्रिय है!\n\nआप **{{date}}** से पहले कभी भी अपना सत्र शुरू कर सकते हैं।\n\nक्या आप अभी सत्र शुरू करना चाहेंगे या बाद में?",
			"expiredBody": "OLX टेस्ट तक आपकी पहुँच **{{date}}** को समाप्त हो गई है।\n\nआगे सहायता के लिए कृपया अपने प्रोफेसर या स्कूल प्रशासक से संपर्क करें।",
			"startNowCta": "अभी शुरू करें",
			"startLaterCta": "बाद में शुरू करें"
		},
		"unexpectedError": "एक अप्रत्याशित त्रुटि हुई।"
	},
	"redeemCode": {
		"titleRedeem": "एक्सेस रिडीम करें",
		"titleGranted": "पहुंच प्रदान की गई",
		"formTitle": "अपना एक्सेस कोड दर्ज करें",
		"accessCodeHint": "यदि आपके पास एक्सेस कोड है, तो कृपया डैश सहित इसे यहां दर्ज करें।",
		"submit": "रिडीम करें",
		"access": "यहां एक्सेस करें",
		"helpFindCode": "अपना कोड ढूंढने में मदद चाहिए?",
		"troubleRedeeming": "रिडीम करने में समस्या हो रही है? सहायक से पूछें!",
		"skipStep": "यह चरण छोड़ें"
	},
	"autoRedeem": {
		"redeem": "रिडीम करें",
		"redeeming": "रिडीम किया जा रहा है...",
		"continue": "जारी रखें",
		"unredeemedPrompt_one": "ईमेल पते **{{email}}** से जुड़ा **{{count}} उत्पाद** है जो रिडीम नहीं किया गया है। क्या आप इसे अपने खाते में जोड़ना चाहेंगे?",
		"unredeemedPrompt_other": "ईमेल पते **{{email}}** से जुड़े **{{count}} उत्पाद** हैं जो रिडीम नहीं किए गए हैं। क्या आप इन्हें अपने खाते में जोड़ना चाहेंगे?",
		"successMessage_one": "बधाई हो! नीचे दिया गया **उत्पाद** आपके खाते में अनलॉक कर दिया गया है। जारी रखें दबाने के बाद, आपके ऐप का संदर्भ बदलकर इस परीक्षा को दर्शाएगा: **{{examName}}**। यदि आप किसी अन्य परीक्षा के लिए अध्ययन करना या कोई अन्य उत्पाद खरीदना चाहते हैं, तो आप इसे कभी भी अपनी खाता सेटिंग से बदल सकते हैं।",
		"successMessage_other": "बधाई हो! नीचे दिए गए **{{count}} उत्पाद** आपके खाते में अनलॉक कर दिए गए हैं। जारी रखें दबाने के बाद, आपके ऐप का संदर्भ बदलकर इस परीक्षा को दर्शाएगा: **{{examName}}**। यदि आप किसी अन्य परीक्षा के लिए अध्ययन करना या कोई अन्य उत्पाद खरीदना चाहते हैं, तो आप इसे कभी भी अपनी खाता सेटिंग से बदल सकते हैं।"
	},
	"olxEligibility": {
		"goToPracticeTests": "प्रैक्टिस टेस्ट पर जाएं"
	},
	"moreChallenges": {
		"challenges": "चैलेंज",
		"challengesCount": "{{value}} चैलेंज"
	},
	"tts": {
		"tooltip": "सुनें"
	},
	"commandBar": {
		"placeholder": "खोजें...",
		"input": {
			"placeholder": "कमांड टाइप करें या खोजें"
		},
		"sections": {
			"quickActions": "त्वरित कार्रवाइयां"
		},
		"actions": {
			"changeExam": "परीक्षा बदलें",
			"switchToDarkMode": "डार्क मोड पर स्विच करें",
			"switchToLightMode": "लाइट मोड पर स्विच करें",
			"setExamDate": "परीक्षा की तारीख़ सेट करें"
		}
	},
	"filterView": {
		"placeholder": "परीक्षाएं खोजें..."
	},
	"transcript": {
		"show": "ट्रांसक्रिप्ट दिखाएं",
		"hide": "ट्रांसक्रिप्ट छिपाएं"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "ऐप लोगो",
			"testNameLabel": "टेस्ट का नाम",
			"sectionLabel": "सेक्शन",
			"back": "वापस जाएं",
			"pause": "रोकें",
			"menuLabel": "अधिक विकल्प"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "टेस्ट प्रगति",
			"of": "में से",
			"pauseSession": "सत्र रोकें",
			"timerTooltip": {
				"item": "इस प्रश्न के लिए शेष समय",
				"section": "इस सेक्शन में शेष समय",
				"test": "इस टेस्ट में शेष समय"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "अगला"
		},
		"progressBar": {
			"timeLeftLabel": "इस प्रश्न के लिए शेष समय",
			"timeLeftForUnit": "इस यूनिट के लिए शेष समय",
			"questionOf": "{{total}} में से प्रश्न {{current}}",
			"questionProgress": "{{total}} में से <b>{{current}}</b>",
			"timesUp": "समय समाप्त",
			"statusTooltips": {
				"answered": "उत्तर दिया गया",
				"inProgress": "प्रगति पर",
				"skipped": "छोड़ा गया",
				"notSeen": "नहीं देखा गया"
			}
		},
		"timeRemainingDialog": {
			"title": "आपके पास अभी भी समय है",
			"body": "इस यूनिट पर अभी भी समय शेष है। क्या आप सबमिट करने से पहले अपने उत्तरों की समीक्षा करना चाहेंगे?",
			"reviewCta": "मेरे उत्तरों की समीक्षा करें"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "स्रोत",
				"answerTitle": "आपका उत्तर",
				"remainingBadge": "{{count}} शेष",
				"placedBadge": "{{count}} रखे गए",
				"pointsBadge": "{{earned}}/{{max}} अंक",
				"emptyHint": "बाएं पैनल से अनुच्छेद यहां खींचें।"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "सहायता जानकारी",
			"emailLabel": "ईमेल",
			"subjectLabel": "विषय",
			"messageBodyLabel": "संदेश सामग्री",
			"appDetailsLabel": "ऐप विवरण",
			"appNameLabel": "नाम",
			"versionLabel": "वर्शन",
			"platformLabel": "प्लेटफ़ॉर्म"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} सहायता सहायक",
			"fallbackTitle": "चैट",
			"betaWarning": "यह AI सहायक **बीटा** में है—प्रतिक्रियाएँ कभी-कभी गलत या अधूरी हो सकती हैं।",
			"greeting": "नमस्ते 👋 क्या आपको किसी उत्पाद तक पहुँच पाने में समस्या हो रही है? मैं आपकी मदद के लिए यहाँ हूँ! पहले, समस्या को समझते हैं। निम्नलिखित में से कौन सा विकल्प आपकी स्थिति का सबसे अच्छा वर्णन करता है?\n\n1. मेरे पास एक एक्सेस कोड है, लेकिन वह काम नहीं कर रहा है।\n2. मैंने खरीदारी की है, लेकिन मुझे अपना एक्सेस कोड नहीं मिल रहा है।\n3. मुझे अपने स्कूल के माध्यम से एक्सेस मिलना चाहिए था, लेकिन मुझे अपना एक्सेस कोड नहीं मिल रहा है।\n4. पहले मेरे पास किसी उत्पाद तक पहुँच थी, लेकिन अभी वह मेरे लिए उपलब्ध नहीं है।\n\nकृपया अपनी समस्या से संबंधित नंबर दर्ज करें।",
			"input": {
				"label": "एक संदेश लिखें...",
				"sendLabel": "भेजें"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 सफलतापूर्वक रिडीम किया गया",
			"previouslyRedeemedTitle": "🚀 पहले रिडीम किया गया",
			"subtitle": "अपनी सामग्री यहाँ एक्सेस करें",
			"expires": "समाप्ति: {{date}}",
			"openCta": "खोलें"
		},
		"purchases": {
			"title": "🎉 एक्सेस कोड मिले",
			"subtitle": "अपनी सामग्री तक पहुँच पाने के लिए रिडीम करें",
			"accessCodesLabel_one": "एक्सेस कोड",
			"accessCodesLabel_other": "एक्सेस कोड",
			"moreCodes_one": "(+ {{count}} और)",
			"moreCodes_other": "(+ {{count}} और)",
			"featuresLabel": "विशेषताएं",
			"redeemCta": "रिडीम करें"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "नया वर्शन उपलब्ध है, कृपया अपडेट करने के लिए रिफ्रेश पर क्लिक करें।",
			"refreshCta": "रिफ्रेश करें",
			"refreshA11yLabel": "ऐप को अपडेट करने के लिए रिफ्रेश करें",
			"dismissTooltip": "खारिज करें",
			"dismissA11yLabel": "अपडेट सूचना खारिज करें"
		}
	},
	"cme": {
		"type": "CME प्रकार",
		"chooseExportMethod": "एक्सपोर्ट विधि चुनें",
		"selectDateRange": "तारीख़ सीमा चुनें",
		"from": "से",
		"to": "तक",
		"sendPdfTo": "{{email}} पर PDF भेजें",
		"downloadCertificate": "प्रमाणपत्र को PDF में डाउनलोड करें",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "अर्जित CME क्रेडिट",
		"confirmYourName": "अपना नाम पुष्ट करें",
		"certificateNameNotice": "यह नाम आपके CME प्रमाणपत्र पर छपेगा।",
		"firstName": "पहला नाम",
		"lastName": "अंतिम नाम",
		"firstNamePlaceholder": "अपना पहला नाम दर्ज करें",
		"lastNamePlaceholder": "अपना अंतिम नाम दर्ज करें",
		"confirm": "पुष्टि करें",
		"creditsEarnedTitle": "अर्जित CME",
		"creditRatioCaption": "12 चैलेंज = 1 CME क्रेडिट",
		"earned": "अर्जित",
		"available": "उपलब्ध",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "CME प्रमाणपत्र एक्सपोर्ट करें",
		"exportDisabledCaption": "अपना प्रमाणपत्र एक्सपोर्ट करने के लिए आपको कम से कम 1 CME क्रेडिट अर्जित करना होगा",
		"viewDisclaimer": "CME अस्वीकरण देखें"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "विवरण",
			"tagsHeading": "टैग",
			"citationsHeading": "संदर्भ",
			"playing": "चल रहा है"
		},
		"a11y": {
			"artwork": "{{title}} का आर्टवर्क",
			"playEpisode": "एपिसोड चलाएँ, {{duration}}",
			"pauseEpisode": "एपिसोड रोकें",
			"play": "चलाएँ",
			"pause": "रोकें",
			"addToQueue": "क़तार में जोड़ें",
			"removeFromQueue": "क़तार से हटाएँ",
			"addBookmark": "बुकमार्क करें",
			"removeBookmark": "बुकमार्क हटाएँ",
			"seekBar": "सीक बार",
			"skipPrevious": "पिछले ट्रैक पर जाएँ",
			"skipNext": "अगले ट्रैक पर जाएँ",
			"rewind": "{{seconds}} सेकंड पीछे जाएँ",
			"fastForward": "{{seconds}} सेकंड आगे बढ़ें",
			"playbackSpeed": "प्लेबैक गति {{speed}}x"
		}
	}
}
